
export const words = [
    {
        "word": "consider",
        "difficulty": 16.38,
        "definition": "deem to be"
    },
    {
        "word": "minute",
        "difficulty": 24.91,
        "definition": "infinitely or immeasurably small"
    },
    {
        "word": "accord",
        "difficulty": 24.93,
        "definition": "concurrence of opinion"
    },
    {
        "word": "evident",
        "difficulty": 29.89,
        "definition": "clearly revealed to the mind or the senses or judgment"
    },
    {
        "word": "practice",
        "difficulty": 32.07,
        "definition": "a customary way of operation or behavior"
    },
    {
        "word": "intend",
        "difficulty": 35.65,
        "definition": "have in mind as a purpose"
    },
    {
        "word": "concern",
        "difficulty": 36.16,
        "definition": "something that interests you because it is important"
    },
    {
        "word": "commit",
        "difficulty": 36.58,
        "definition": "perform an act, usually with a negative connotation"
    },
    {
        "word": "issue",
        "difficulty": 41.47,
        "definition": "some situation or event that is thought about"
    },
    {
        "word": "approach",
        "difficulty": 42.27,
        "definition": "move towards"
    },
    {
        "word": "establish",
        "difficulty": 44.37,
        "definition": "set up or found"
    },
    {
        "word": "utter",
        "difficulty": 45.01,
        "definition": "without qualification"
    },
    {
        "word": "conduct",
        "difficulty": 46.46,
        "definition": "direct the course of; manage or control"
    },
    {
        "word": "engage",
        "difficulty": 47.05,
        "definition": "consume all of one's attention or time"
    },
    {
        "word": "obtain",
        "difficulty": 48.23,
        "definition": "come into possession of"
    },
    {
        "word": "scarce",
        "difficulty": 49.44,
        "definition": "deficient in quantity or number compared with the demand"
    },
    {
        "word": "policy",
        "difficulty": 54.33,
        "definition": "a plan of action adopted by an individual or social group"
    },
    {
        "word": "straight",
        "difficulty": 55.08,
        "definition": "successive, without a break"
    },
    {
        "word": "stock",
        "difficulty": 55.5,
        "definition": "capital raised by a corporation through the issue of shares"
    },
    {
        "word": "apparent",
        "difficulty": 56.65,
        "definition": "clearly revealed to the mind or the senses or judgment"
    },
    {
        "word": "property",
        "difficulty": 57.16,
        "definition": "a basic or essential attribute shared by members of a class"
    },
    {
        "word": "fancy",
        "difficulty": 58.41,
        "definition": "imagine; conceive of; see in one's mind"
    },
    {
        "word": "concept",
        "difficulty": 58.97,
        "definition": "an abstract or general idea inferred from specific instances"
    },
    {
        "word": "court",
        "difficulty": 59.1,
        "definition": "an assembly to conduct judicial business"
    },
    {
        "word": "appoint",
        "difficulty": 59.5,
        "definition": "assign a duty, responsibility, or obligation to"
    },
    {
        "word": "passage",
        "difficulty": 60.1,
        "definition": "a section of text, particularly a section of medium length"
    },
    {
        "word": "vain",
        "difficulty": 60.34,
        "definition": "unproductive of success"
    },
    {
        "word": "instance",
        "difficulty": 61.11,
        "definition": "an occurrence of something"
    },
    {
        "word": "coast",
        "difficulty": 62.11,
        "definition": "the shore of a sea or ocean"
    },
    {
        "word": "project",
        "difficulty": 63.04,
        "definition": "a planned undertaking"
    },
    {
        "word": "commission",
        "difficulty": 63.58,
        "definition": "a special group delegated to consider some matter"
    },
    {
        "word": "constant",
        "difficulty": 63.6,
        "definition": "a quantity that does not vary"
    },
    {
        "word": "circumstances",
        "difficulty": 64.7,
        "definition": "one's overall condition in life"
    },
    {
        "word": "constitute",
        "difficulty": 64.39,
        "definition": "compose or represent"
    },
    {
        "word": "level",
        "difficulty": 65.59,
        "definition": "a relative position or degree of value in a graded group"
    },
    {
        "word": "affect",
        "difficulty": 67.76,
        "definition": "have an influence upon"
    },
    {
        "word": "institute",
        "difficulty": 68.34,
        "definition": "set up or lay the groundwork for"
    },
    {
        "word": "render",
        "difficulty": 69.29,
        "definition": "give an interpretation of"
    },
    {
        "word": "appeal",
        "difficulty": 72.01,
        "definition": "be attractive to"
    },
    {
        "word": "generate",
        "difficulty": 72.5,
        "definition": "bring into existence"
    },
    {
        "word": "theory",
        "difficulty": 75.57,
        "definition": "a well-substantiated explanation of some aspect of the world"
    },
    {
        "word": "range",
        "difficulty": 75.97,
        "definition": "a variety of different things or activities"
    },
    {
        "word": "campaign",
        "difficulty": 76.75,
        "definition": "a race between candidates for elective office"
    },
    {
        "word": "league",
        "difficulty": 77.72,
        "definition": "an association of sports teams that organizes matches"
    },
    {
        "word": "labor",
        "difficulty": 78.33,
        "definition": "any piece of work that is undertaken or attempted"
    },
    {
        "word": "confer",
        "difficulty": 79.5,
        "definition": "have a meeting in order to talk something over"
    },
    {
        "word": "grant",
        "difficulty": 80.51,
        "definition": "allow to have"
    },
    {
        "word": "dwell",
        "difficulty": 80.52,
        "definition": "think moodily or anxiously about something"
    },
    {
        "word": "entertain",
        "difficulty": 81.81,
        "definition": "provide amusement for"
    },
    {
        "word": "contract",
        "difficulty": 83.11,
        "definition": "a binding agreement that is enforceable by law"
    },
    {
        "word": "earnest",
        "difficulty": 83.77,
        "definition": "characterized by a firm, humorless belief in one's opinions"
    },
    {
        "word": "yield",
        "difficulty": 85.89,
        "definition": "give or supply"
    },
    {
        "word": "wander",
        "difficulty": 88.34,
        "definition": "move or cause to move in a sinuous or circular course"
    },
    {
        "word": "insist",
        "difficulty": 78.94,
        "definition": "be emphatic or resolute and refuse to budge"
    },
    {
        "word": "knight",
        "difficulty": 88.69,
        "definition": "a person of noble birth trained to arms and chivalry"
    },
    {
        "word": "convince",
        "difficulty": 89.31,
        "definition": "make realize the truth or validity of something"
    },
    {
        "word": "inspire",
        "difficulty": 89.32,
        "definition": "serve as the inciting cause of"
    },
    {
        "word": "convention",
        "difficulty": 91.48,
        "definition": "a large formal assembly"
    },
    {
        "word": "skill",
        "difficulty": 92.7,
        "definition": "an ability that has been acquired by training"
    },
    {
        "word": "harry",
        "difficulty": 94.64,
        "definition": "annoy continually or chronically"
    },
    {
        "word": "financial",
        "difficulty": 95.49,
        "definition": "involving fiscal matters"
    },
    {
        "word": "reflect",
        "difficulty": 61.02,
        "definition": "show an image of"
    },
    {
        "word": "novel",
        "difficulty": 96.86,
        "definition": "an extended fictional work in prose"
    },
    {
        "word": "furnish",
        "difficulty": 97.01,
        "definition": "provide with objects or articles that make a room usable"
    },
    {
        "word": "compel",
        "difficulty": 97.22,
        "definition": "force somebody to do something"
    },
    {
        "word": "venture",
        "difficulty": 98.96,
        "definition": "proceed somewhere despite the risk of possible dangers"
    },
    {
        "word": "territory",
        "difficulty": 99.54,
        "definition": "the geographical area under the jurisdiction of a state"
    },
    {
        "word": "temper",
        "difficulty": 103.42,
        "definition": "a characteristic state of feeling"
    },
    {
        "word": "bent",
        "difficulty": 106.48,
        "definition": "fixed in your purpose"
    },
    {
        "word": "intimate",
        "difficulty": 107.62,
        "definition": "marked by close acquaintance, association, or familiarity"
    },
    {
        "word": "undertake",
        "difficulty": 108,
        "definition": "enter upon an activity or enterprise"
    },
    {
        "word": "majority",
        "difficulty": 108.69,
        "definition": "more than half of the votes in an election"
    },
    {
        "word": "assert",
        "difficulty": 109.2,
        "definition": "declare or affirm solemnly and formally as true"
    },
    {
        "word": "crew",
        "difficulty": 111.51,
        "definition": "the people who work on a vehicle"
    },
    {
        "word": "chamber",
        "difficulty": 112.98,
        "definition": "a natural or artificial enclosed space"
    },
    {
        "word": "humble",
        "difficulty": 113.28,
        "definition": "marked by meekness or modesty; not arrogant or prideful"
    },
    {
        "word": "scheme",
        "difficulty": 113.77,
        "definition": "an elaborate and systematic plan of action"
    },
    {
        "word": "keen",
        "difficulty": 114.85,
        "definition": "demonstrating ability to recognize or draw fine distinctions"
    },
    {
        "word": "liberal",
        "difficulty": 111.23,
        "definition": "having political views favoring reform and progress"
    },
    {
        "word": "despair",
        "difficulty": 117.43,
        "definition": "a state in which all hope is lost or absent"
    },
    {
        "word": "tide",
        "difficulty": 117.68,
        "definition": "the periodic rise and fall of the sea level"
    },
    {
        "word": "attitude",
        "difficulty": 118.37,
        "definition": "a complex mental state involving beliefs and feelings"
    },
    {
        "word": "justify",
        "difficulty": 118.43,
        "definition": "show to be reasonable or provide adequate ground for"
    },
    {
        "word": "flag",
        "difficulty": 120.36,
        "definition": "a rectangular piece of cloth of distinctive design"
    },
    {
        "word": "merit",
        "difficulty": 123.51,
        "definition": "any admirable or beneficial attribute"
    },
    {
        "word": "manifest",
        "difficulty": 126.01,
        "definition": "reveal its presence or make an appearance"
    },
    {
        "word": "notion",
        "difficulty": 132.58,
        "definition": "a general inclusive concept"
    },
    {
        "word": "scale",
        "difficulty": 134.12,
        "definition": "relative magnitude"
    },
    {
        "word": "formal",
        "difficulty": 134.41,
        "definition": "characteristic of or befitting a person in authority"
    },
    {
        "word": "resource",
        "difficulty": 139.37,
        "definition": "a new or reserve supply that can be drawn upon when needed"
    },
    {
        "word": "persist",
        "difficulty": 154.09,
        "definition": "continue to exist"
    },
    {
        "word": "contempt",
        "difficulty": 155.44,
        "definition": "lack of respect accompanied by a feeling of intense dislike"
    },
    {
        "word": "tour",
        "difficulty": 107.52,
        "definition": "a route all the way around a particular place or area"
    },
    {
        "word": "plead",
        "difficulty": 160.48,
        "definition": "enter a defendant's answer"
    },
    {
        "word": "weigh",
        "difficulty": 161.51,
        "definition": "be oppressive or burdensome"
    },
    {
        "word": "mode",
        "difficulty": 161.79,
        "definition": "how something is done or how it happens"
    },
    {
        "word": "distinction",
        "difficulty": 164.02,
        "definition": "a discrimination between things as different"
    },
    {
        "word": "inclined",
        "difficulty": 166.33,
        "definition": "at an angle to the horizontal or vertical position"
    },
    {
        "word": "attribute",
        "difficulty": 167.16,
        "definition": "a quality belonging to or characteristic of an entity"
    },
    {
        "word": "exert",
        "difficulty": 168.36,
        "definition": "make a great effort at a mental or physical task"
    },
    {
        "word": "oppress",
        "difficulty": 170.91,
        "definition": "come down on or keep down by unjust use of one's authority"
    },
    {
        "word": "contend",
        "difficulty": 175.36,
        "definition": "compete for something"
    },
    {
        "word": "stake",
        "difficulty": 177.94,
        "definition": "a strong wooden or metal post driven into the ground"
    },
    {
        "word": "toil",
        "difficulty": 179.49,
        "definition": "work hard"
    },
    {
        "word": "perish",
        "difficulty": 180.44,
        "definition": "pass from physical life"
    },
    {
        "word": "disposition",
        "difficulty": 181.69,
        "definition": "your usual mood"
    },
    {
        "word": "rail",
        "difficulty": 187,
        "definition": "complain bitterly"
    },
    {
        "word": "cardinal",
        "difficulty": 188.31,
        "definition": "one of a group of prominent bishops in the Sacred College"
    },
    {
        "word": "boast",
        "difficulty": 191.56,
        "definition": "talk about oneself with excessive pride or self-regard"
    },
    {
        "word": "advocate",
        "difficulty": 191.83,
        "definition": "a person who pleads for a person, cause, or idea"
    },
    {
        "word": "bestow",
        "difficulty": 193.13,
        "definition": "present"
    },
    {
        "word": "allege",
        "difficulty": 193.55,
        "definition": "report or maintain"
    },
    {
        "word": "notwithstanding",
        "difficulty": 193.95,
        "definition": "despite anything to the contrary"
    },
    {
        "word": "lofty",
        "difficulty": 194.91,
        "definition": "of imposing height; especially standing out above others"
    },
    {
        "word": "multitude",
        "difficulty": 196.75,
        "definition": "a large indefinite number"
    },
    {
        "word": "steep",
        "difficulty": 197.17,
        "definition": "having a sharp inclination"
    },
    {
        "word": "heed",
        "difficulty": 202.8,
        "definition": "pay close attention to"
    },
    {
        "word": "modest",
        "difficulty": 208.4,
        "definition": "not large but sufficient in size or amount"
    },
    {
        "word": "partial",
        "difficulty": 213.59,
        "definition": "being or affecting only a segment"
    },
    {
        "word": "apt",
        "difficulty": 215.48,
        "definition": "naturally disposed toward"
    },
    {
        "word": "esteem",
        "difficulty": 215.88,
        "definition": "the condition of being honored"
    },
    {
        "word": "credible",
        "difficulty": 220.33,
        "definition": "appearing to merit belief or acceptance"
    },
    {
        "word": "provoke",
        "difficulty": 220.83,
        "definition": "provide the needed stimulus for"
    },
    {
        "word": "tread",
        "difficulty": 220.92,
        "definition": "a step in walking or running"
    },
    {
        "word": "ascertain",
        "difficulty": 228.25,
        "definition": "learn or discover with confidence"
    },
    {
        "word": "fare",
        "difficulty": 235.7,
        "definition": "proceed, get along, or succeed"
    },
    {
        "word": "cede",
        "difficulty": 235.76,
        "definition": "relinquish possession or control over"
    },
    {
        "word": "perpetual",
        "difficulty": 236.04,
        "definition": "continuing forever or indefinitely"
    },
    {
        "word": "decree",
        "difficulty": 237.13,
        "definition": "a legally binding command or decision"
    },
    {
        "word": "contrive",
        "difficulty": 241.01,
        "definition": "make or work out a plan for; devise"
    },
    {
        "word": "derived",
        "difficulty": 242.31,
        "definition": "formed or developed from something else; not original"
    },
    {
        "word": "elaborate",
        "difficulty": 246.11,
        "definition": "marked by complexity and richness of detail"
    },
    {
        "word": "substantial",
        "difficulty": 248.39,
        "definition": "real; having a material or factual existence"
    },
    {
        "word": "frontier",
        "difficulty": 248.41,
        "definition": "a wilderness at the edge of a settled area of a country"
    },
    {
        "word": "facile",
        "difficulty": 249.65,
        "definition": "arrived at without due care or effort; lacking depth"
    },
    {
        "word": "cite",
        "difficulty": 253.25,
        "definition": "make reference to"
    },
    {
        "word": "warrant",
        "difficulty": 254.73,
        "definition": "show to be reasonable or provide adequate ground for"
    },
    {
        "word": "sob",
        "difficulty": 254.93,
        "definition": "weep convulsively"
    },
    {
        "word": "rider",
        "difficulty": 255.96,
        "definition": "a traveler who actively sits and travels on an animal"
    },
    {
        "word": "dense",
        "difficulty": 256,
        "definition": "permitting little if any light to pass through"
    },
    {
        "word": "afflict",
        "difficulty": 258.03,
        "definition": "cause physical pain or suffering in"
    },
    {
        "word": "flourish",
        "difficulty": 262.3,
        "definition": "grow vigorously"
    },
    {
        "word": "ordain",
        "difficulty": 274.11,
        "definition": "invest with ministerial or priestly authority"
    },
    {
        "word": "pious",
        "difficulty": 274.72,
        "definition": "having or showing or expressing reverence for a deity"
    },
    {
        "word": "vex",
        "difficulty": 282.28,
        "definition": "disturb, especially by minor irritations"
    },
    {
        "word": "gravity",
        "difficulty": 287.13,
        "definition": "the force of attraction between all masses in the universe"
    },
    {
        "word": "suspended",
        "difficulty": 287.98,
        "definition": "supported or kept from sinking or falling by buoyancy"
    },
    {
        "word": "conspicuous",
        "difficulty": 288.02,
        "definition": "obvious to the eye or mind"
    },
    {
        "word": "retort",
        "difficulty": 292.37,
        "definition": "a quick reply to a question or remark"
    },
    {
        "word": "jet",
        "difficulty": 294.03,
        "definition": "an airplane powered by gas turbines"
    },
    {
        "word": "bolt",
        "difficulty": 294.79,
        "definition": "run away"
    },
    {
        "word": "assent",
        "difficulty": 296.46,
        "definition": "agree or express agreement"
    },
    {
        "word": "purse",
        "difficulty": 298.18,
        "definition": "a sum spoken of as the contents of a money container"
    },
    {
        "word": "plus",
        "difficulty": 299.53,
        "definition": "the arithmetic operation of summing"
    },
    {
        "word": "sanction",
        "difficulty": 301.53,
        "definition": "give authority or permission to"
    },
    {
        "word": "proceeding",
        "difficulty": 303.45,
        "definition": "a sequence of steps by which legal judgments are invoked"
    },
    {
        "word": "exalt",
        "difficulty": 305.43,
        "definition": "praise, glorify, or honor"
    },
    {
        "word": "siege",
        "difficulty": 305.54,
        "definition": "an action of an armed force that surrounds a fortified place"
    },
    {
        "word": "malice",
        "difficulty": 307.19,
        "definition": "the desire to see others suffer"
    },
    {
        "word": "extravagant",
        "difficulty": 307.84,
        "definition": "recklessly wasteful"
    },
    {
        "word": "wax",
        "difficulty": 312.61,
        "definition": "increase in phase"
    },
    {
        "word": "throng",
        "difficulty": 312.73,
        "definition": "press tightly together or cram"
    },
    {
        "word": "venerate",
        "difficulty": 313.53,
        "definition": "regard with feelings of respect and reverence"
    },
    {
        "word": "assail",
        "difficulty": 317.8,
        "definition": "attack someone physically or emotionally"
    },
    {
        "word": "sublime",
        "difficulty": 320.67,
        "definition": "of high moral or intellectual value"
    },
    {
        "word": "exploit",
        "difficulty": 324,
        "definition": "draw from; make good use of"
    },
    {
        "word": "exertion",
        "difficulty": 326.34,
        "definition": "use of physical or mental energy; hard work"
    },
    {
        "word": "kindle",
        "difficulty": 327.69,
        "definition": "catch fire"
    },
    {
        "word": "endow",
        "difficulty": 328.41,
        "definition": "furnish with a capital fund"
    },
    {
        "word": "imposed",
        "difficulty": 331.57,
        "definition": "set forth authoritatively as obligatory"
    },
    {
        "word": "humiliate",
        "difficulty": 332.2,
        "definition": "cause to feel shame"
    },
    {
        "word": "suffrage",
        "difficulty": 333.42,
        "definition": "a legal right to vote"
    },
    {
        "word": "ensue",
        "difficulty": 334.6,
        "definition": "take place or happen afterward or as a result"
    },
    {
        "word": "brook",
        "difficulty": 336.09,
        "definition": "a natural stream of water smaller than a river"
    },
    {
        "word": "gale",
        "difficulty": 336.54,
        "definition": "a strong wind moving 34–40 knots"
    },
    {
        "word": "muse",
        "difficulty": 347.29,
        "definition": "reflect deeply on a subject"
    },
    {
        "word": "satire",
        "difficulty": 349.69,
        "definition": "witty language used to convey insults or scorn"
    },
    {
        "word": "intrigue",
        "difficulty": 353.08,
        "definition": "cause to be interested or curious"
    },
    {
        "word": "indication",
        "difficulty": 354.99,
        "definition": "something that serves to suggest"
    },
    {
        "word": "dispatch",
        "difficulty": 365.61,
        "definition": "send away towards a designated goal"
    },
    {
        "word": "cower",
        "difficulty": 367.76,
        "definition": "crouch or curl up"
    },
    {
        "word": "wont",
        "difficulty": 370.15,
        "definition": "an established custom"
    },
    {
        "word": "tract",
        "difficulty": 374.88,
        "definition": "a system of body parts that serves some specialized purpose"
    },
    {
        "word": "canon",
        "difficulty": 377.86,
        "definition": "a collection of books accepted as holy scripture"
    },
    {
        "word": "impel",
        "difficulty": 378.99,
        "definition": "cause to move forward with force"
    },
    {
        "word": "latitude",
        "difficulty": 382.4,
        "definition": "freedom from normal restraints in conduct"
    },
    {
        "word": "vacate",
        "difficulty": 393.56,
        "definition": "leave behind empty; move out of"
    },
    {
        "word": "undertaking",
        "difficulty": 397.24,
        "definition": "any piece of work that is attempted"
    },
    {
        "word": "slay",
        "difficulty": 399.25,
        "definition": "kill intentionally and with premeditation"
    },
    {
        "word": "predecessor",
        "difficulty": 401.89,
        "definition": "one who goes before you in time"
    },
    {
        "word": "delicacy",
        "difficulty": 406.92,
        "definition": "the quality of being exquisitely fine in appearance"
    },
    {
        "word": "forsake",
        "difficulty": 407.05,
        "definition": "leave someone who needs or counts on you; leave in the lurch"
    },
    {
        "word": "beseech",
        "difficulty": 420.18,
        "definition": "ask for or request earnestly"
    },
    {
        "word": "philosophical",
        "difficulty": 422.14,
        "definition": "relating to the investigation of existence and knowledge"
    },
    {
        "word": "grove",
        "difficulty": 422.91,
        "definition": "a small growth of trees without underbrush"
    },
    {
        "word": "frustrate",
        "difficulty": 423.18,
        "definition": "hinder or prevent, as an effort, plan, or desire"
    },
    {
        "word": "illustrious",
        "difficulty": 427.71,
        "definition": "widely known and esteemed"
    },
    {
        "word": "device",
        "difficulty": 193.37,
        "definition": "an instrumentality invented for a particular purpose"
    },
    {
        "word": "pomp",
        "difficulty": 430.54,
        "definition": "cheap or pretentious or vain display"
    },
    {
        "word": "entreat",
        "difficulty": 433.99,
        "definition": "ask for or request earnestly"
    },
    {
        "word": "impart",
        "difficulty": 435.82,
        "definition": "transmit, as knowledge or a skill"
    },
    {
        "word": "propriety",
        "difficulty": 440.15,
        "definition": "correct behavior"
    },
    {
        "word": "consecrate",
        "difficulty": 449.36,
        "definition": "render holy by means of religious rites"
    },
    {
        "word": "proceeds",
        "difficulty": 450.16,
        "definition": "the income or profit arising from a transaction"
    },
    {
        "word": "fathom",
        "difficulty": 450.92,
        "definition": "come to understand"
    },
    {
        "word": "objective",
        "difficulty": 454.25,
        "definition": "the goal intended to be attained"
    },
    {
        "word": "clad",
        "difficulty": 458.72,
        "definition": "wearing or provided with clothing"
    },
    {
        "word": "partisan",
        "difficulty": 460.32,
        "definition": "devoted to a cause or political group"
    },
    {
        "word": "faction",
        "difficulty": 474.32,
        "definition": "a dissenting clique"
    },
    {
        "word": "contrived",
        "difficulty": 476.76,
        "definition": "artificially formal"
    },
    {
        "word": "venerable",
        "difficulty": 480.14,
        "definition": "impressive by reason of age"
    },
    {
        "word": "restrained",
        "difficulty": 505.54,
        "definition": "not showy or obtrusive"
    },
    {
        "word": "besiege",
        "difficulty": 507.72,
        "definition": "harass, as with questions or requests"
    },
    {
        "word": "manifestation",
        "difficulty": 513.01,
        "definition": "a clear appearance"
    },
    {
        "word": "rebuke",
        "difficulty": 516.9,
        "definition": "an act or expression of criticism and censure"
    },
    {
        "word": "insurgent",
        "difficulty": 518.66,
        "definition": "in opposition to a civil authority or government"
    },
    {
        "word": "rhetoric",
        "difficulty": 520.85,
        "definition": "using language effectively to please or persuade"
    },
    {
        "word": "scrupulous",
        "difficulty": 524.07,
        "definition": "having ethical or moral principles"
    },
    {
        "word": "ratify",
        "difficulty": 524.07,
        "definition": "approve and express assent, responsibility, or obligation"
    },
    {
        "word": "stump",
        "difficulty": 526.12,
        "definition": "cause to be perplexed or confounded"
    },
    {
        "word": "discreet",
        "difficulty": 530.94,
        "definition": "marked by prudence or modesty and wise self-restraint"
    },
    {
        "word": "imposing",
        "difficulty": 532.99,
        "definition": "impressive in appearance"
    },
    {
        "word": "wistful",
        "difficulty": 533.09,
        "definition": "showing pensive sadness"
    },
    {
        "word": "mortify",
        "difficulty": 534.96,
        "definition": "cause to feel shame"
    },
    {
        "word": "ripple",
        "difficulty": 544.04,
        "definition": "stir up so as to form small waves"
    },
    {
        "word": "premise",
        "difficulty": 548.95,
        "definition": "a statement that is held to be true"
    },
    {
        "word": "subside",
        "difficulty": 551.97,
        "definition": "wear off or die down"
    },
    {
        "word": "adverse",
        "difficulty": 552.27,
        "definition": "contrary to your interests or welfare"
    },
    {
        "word": "caprice",
        "difficulty": 552.3,
        "definition": "a sudden desire"
    },
    {
        "word": "muster",
        "difficulty": 565.38,
        "definition": "gather or bring together"
    },
    {
        "word": "comprehensive",
        "difficulty": 568.85,
        "definition": "broad in scope"
    },
    {
        "word": "accede",
        "difficulty": 569.07,
        "definition": "yield to another's wish or opinion"
    },
    {
        "word": "fervent",
        "difficulty": 570.58,
        "definition": "characterized by intense emotion"
    },
    {
        "word": "cohere",
        "difficulty": 571.9,
        "definition": "cause to form a united, orderly, and consistent whole"
    },
    {
        "word": "tribunal",
        "difficulty": 580.78,
        "definition": "an assembly to conduct judicial business"
    },
    {
        "word": "austere",
        "difficulty": 583.49,
        "definition": "severely simple"
    },
    {
        "word": "recovering",
        "difficulty": 584.32,
        "definition": "returning to health after illness or debility"
    },
    {
        "word": "stratum",
        "difficulty": 589.52,
        "definition": "people having the same social or economic status"
    },
    {
        "word": "conscientious",
        "difficulty": 596.49,
        "definition": "characterized by extreme care and great effort"
    },
    {
        "word": "arbitrary",
        "difficulty": 598.81,
        "definition": "based on or subject to individual discretion or preference"
    },
    {
        "word": "exasperate",
        "difficulty": 602.61,
        "definition": "irritate"
    },
    {
        "word": "conjure",
        "difficulty": 604.12,
        "definition": "summon into action or bring into existence"
    },
    {
        "word": "ominous",
        "difficulty": 624.02,
        "definition": "threatening or foreshadowing evil or tragic developments"
    },
    {
        "word": "edifice",
        "difficulty": 635.83,
        "definition": "a structure that has a roof and walls"
    },
    {
        "word": "elude",
        "difficulty": 637.95,
        "definition": "escape, either physically or mentally"
    },
    {
        "word": "pervade",
        "difficulty": 643.46,
        "definition": "spread or diffuse through"
    },
    {
        "word": "foster",
        "difficulty": 651.31,
        "definition": "promote the growth of"
    },
    {
        "word": "admonish",
        "difficulty": 652.7,
        "definition": "scold or reprimand; take to task"
    },
    {
        "word": "repeal",
        "difficulty": 653.06,
        "definition": "cancel officially"
    },
    {
        "word": "retiring",
        "difficulty": 653.89,
        "definition": "not arrogant or presuming"
    },
    {
        "word": "incidental",
        "difficulty": 654.65,
        "definition": "not of prime or central importance"
    },
    {
        "word": "acquiesce",
        "difficulty": 656.06,
        "definition": "agree or express agreement"
    },
    {
        "word": "slew",
        "difficulty": 656.5,
        "definition": "a large number or amount or extent"
    },
    {
        "word": "usurp",
        "difficulty": 658.69,
        "definition": "seize and take control without authority"
    },
    {
        "word": "sentinel",
        "difficulty": 668.64,
        "definition": "a person employed to keep watch for some anticipated event"
    },
    {
        "word": "precision",
        "difficulty": 675.27,
        "definition": "the quality of being exact"
    },
    {
        "word": "depose",
        "difficulty": 678.83,
        "definition": "force to leave an office"
    },
    {
        "word": "wanton",
        "difficulty": 684.24,
        "definition": "unprovoked or without motive or justification"
    },
    {
        "word": "odium",
        "difficulty": 688.53,
        "definition": "state of disgrace resulting from detestable behavior"
    },
    {
        "word": "precept",
        "difficulty": 691.78,
        "definition": "a rule of personal conduct"
    },
    {
        "word": "deference",
        "difficulty": 698.55,
        "definition": "a courteous expression of esteem or regard"
    },
    {
        "word": "fray",
        "difficulty": 711.38,
        "definition": "a noisy fight"
    },
    {
        "word": "candid",
        "difficulty": 713.99,
        "definition": "openly straightforward and direct without secretiveness"
    },
    {
        "word": "enduring",
        "difficulty": 719.89,
        "definition": "unceasing"
    },
    {
        "word": "impertinent",
        "difficulty": 722.35,
        "definition": "improperly forward or bold"
    },
    {
        "word": "bland",
        "difficulty": 731.31,
        "definition": "lacking stimulating characteristics; uninteresting"
    },
    {
        "word": "insinuate",
        "difficulty": 733.16,
        "definition": "suggest in an indirect or covert way; give to understand"
    },
    {
        "word": "nominal",
        "difficulty": 714.94,
        "definition": "insignificantly small; a matter of form only"
    },
    {
        "word": "suppliant",
        "difficulty": 757.92,
        "definition": "humbly entreating"
    },
    {
        "word": "languid",
        "difficulty": 767.99,
        "definition": "lacking spirit or liveliness"
    },
    {
        "word": "rave",
        "difficulty": 777.31,
        "definition": "praise enthusiastically"
    },
    {
        "word": "monetary",
        "difficulty": 770.84,
        "definition": "relating to or involving money"
    },
    {
        "word": "headlong",
        "difficulty": 781.05,
        "definition": "in a hasty and foolhardy manner"
    },
    {
        "word": "infallible",
        "difficulty": 784.57,
        "definition": "incapable of failure or error"
    },
    {
        "word": "coax",
        "difficulty": 791.01,
        "definition": "influence or urge by gentle urging, caressing, or flattering"
    },
    {
        "word": "explicate",
        "difficulty": 811.87,
        "definition": "elaborate, as of theories and hypotheses"
    },
    {
        "word": "gaunt",
        "difficulty": 823.16,
        "definition": "very thin especially from disease or hunger or cold"
    },
    {
        "word": "morbid",
        "difficulty": 824.88,
        "definition": "suggesting the horror of death and decay"
    },
    {
        "word": "ranging",
        "difficulty": 826.14,
        "definition": "wandering freely"
    },
    {
        "word": "pacify",
        "difficulty": 826.26,
        "definition": "ease the anger, agitation, or strong emotion of"
    },
    {
        "word": "pastoral",
        "difficulty": 833.64,
        "definition": "idyllically rustic"
    },
    {
        "word": "dogged",
        "difficulty": 844.63,
        "definition": "stubbornly unyielding"
    },
    {
        "word": "ebb",
        "difficulty": 847.17,
        "definition": "fall away or decline"
    },
    {
        "word": "aide",
        "difficulty": 853.27,
        "definition": "someone who acts as an assistant"
    },
    {
        "word": "appease",
        "difficulty": 862.03,
        "definition": "cause to be more favorably inclined; gain the good will of"
    },
    {
        "word": "stipulate",
        "difficulty": 868.79,
        "definition": "make an express demand or provision in an agreement"
    },
    {
        "word": "recourse",
        "difficulty": 889.6,
        "definition": "something or someone turned to for assistance or security"
    },
    {
        "word": "constrained",
        "difficulty": 902.41,
        "definition": "lacking spontaneity; not natural"
    },
    {
        "word": "bate",
        "difficulty": 905.59,
        "definition": "moderate or restrain; lessen the force of"
    },
    {
        "word": "aversion",
        "difficulty": 906,
        "definition": "a feeling of intense dislike"
    },
    {
        "word": "conceit",
        "difficulty": 915.45,
        "definition": "an artistic device or effect"
    },
    {
        "word": "loath",
        "difficulty": 933.71,
        "definition": "strongly opposed"
    },
    {
        "word": "rampart",
        "difficulty": 937.78,
        "definition": "an embankment built around a space for defensive purposes"
    },
    {
        "word": "extort",
        "difficulty": 939.71,
        "definition": "obtain by coercion or intimidation"
    },
    {
        "word": "tarry",
        "difficulty": 941.43,
        "definition": "leave slowly and hesitantly"
    },
    {
        "word": "perpetrate",
        "difficulty": 942.63,
        "definition": "perform an act, usually with a negative connotation"
    },
    {
        "word": "decorum",
        "difficulty": 944.36,
        "definition": "propriety in manners and conduct"
    },
    {
        "word": "luxuriant",
        "difficulty": 951.33,
        "definition": "produced or growing in extreme abundance"
    },
    {
        "word": "cant",
        "difficulty": 952.64,
        "definition": "insincere talk about religion or morals"
    },
    {
        "word": "enjoin",
        "difficulty": 964.98,
        "definition": "give instructions to or direct somebody to do something"
    },
    {
        "word": "avarice",
        "difficulty": 965.84,
        "definition": "extreme greed for material wealth"
    },
    {
        "word": "edict",
        "difficulty": 971.87,
        "definition": "a formal or authoritative proclamation"
    },
    {
        "word": "disconcert",
        "difficulty": 977.24,
        "definition": "cause to lose one's composure"
    },
    {
        "word": "symmetry",
        "difficulty": 989.15,
        "definition": "balance among the parts of something"
    },
    {
        "word": "capitulate",
        "difficulty": 999.17,
        "definition": "surrender under agreed conditions"
    },
    {
        "word": "arbitrate",
        "difficulty": 1000.35,
        "definition": "act between parties with a view to reconciling differences"
    },
    {
        "word": "cleave",
        "difficulty": 1009.22,
        "definition": "separate or cut with a tool, such as a sharp instrument"
    },
    {
        "word": "append",
        "difficulty": 1015.01,
        "definition": "add to the very end"
    },
    {
        "word": "visage",
        "difficulty": 1028.32,
        "definition": "the human face"
    },
    {
        "word": "horde",
        "difficulty": 1028.68,
        "definition": "a moving crowd"
    },
    {
        "word": "parable",
        "difficulty": 1092.35,
        "definition": "a short moral story"
    },
    {
        "word": "chastise",
        "difficulty": 1031.27,
        "definition": "censure severely"
    },
    {
        "word": "foil",
        "difficulty": 1033.98,
        "definition": "hinder or prevent, as an effort, plan, or desire"
    },
    {
        "word": "veritable",
        "difficulty": 1037.87,
        "definition": "being truly so called; real or genuine"
    },
    {
        "word": "grapple",
        "difficulty": 1043.27,
        "definition": "work hard to come to terms with or deal with something"
    },
    {
        "word": "gentry",
        "difficulty": 1048.53,
        "definition": "the most powerful members of a society"
    },
    {
        "word": "pall",
        "difficulty": 1049,
        "definition": "a sudden numbing dread"
    },
    {
        "word": "maxim",
        "difficulty": 1049.28,
        "definition": "a saying that is widely accepted on its own merits"
    },
    {
        "word": "projection",
        "difficulty": 1050.77,
        "definition": "a prediction made by extrapolating from past observations"
    },
    {
        "word": "prowess",
        "difficulty": 1067.82,
        "definition": "a superior skill learned by study and practice"
    },
    {
        "word": "dingy",
        "difficulty": 1075.68,
        "definition": "thickly covered with ingrained dirt or soot"
    },
    {
        "word": "semblance",
        "difficulty": 1083.35,
        "definition": "the outward or apparent appearance or form of something"
    },
    {
        "word": "tout",
        "difficulty": 1089.53,
        "definition": "advertise in strongly positive terms"
    },
    {
        "word": "fortitude",
        "difficulty": 1090.74,
        "definition": "strength of mind that enables one to endure adversity"
    },
    {
        "word": "asunder",
        "difficulty": 1094.47,
        "definition": "into parts or pieces"
    },
    {
        "word": "rout",
        "difficulty": 1095.38,
        "definition": "an overwhelming defeat"
    },
    {
        "word": "staid",
        "difficulty": 1098.73,
        "definition": "characterized by dignity and propriety"
    },
    {
        "word": "beguile",
        "difficulty": 1103.65,
        "definition": "influence by slyness"
    },
    {
        "word": "purport",
        "difficulty": 1106.02,
        "definition": "have the often misleading appearance of being or intending"
    },
    {
        "word": "deprave",
        "difficulty": 1112.57,
        "definition": "corrupt morally or by intemperance or sensuality"
    },
    {
        "word": "bequeath",
        "difficulty": 1113.72,
        "definition": "leave or give, especially by will after one's death"
    },
    {
        "word": "enigma",
        "difficulty": 1126.43,
        "definition": "something that baffles understanding and cannot be explained"
    },
    {
        "word": "assiduous",
        "difficulty": 1132.58,
        "definition": "marked by care and persistent effort"
    },
    {
        "word": "vassal",
        "difficulty": 1135.62,
        "definition": "a person who owes allegiance and service to a feudal lord"
    },
    {
        "word": "quail",
        "difficulty": 1141.86,
        "definition": "draw back, as with fear or pain"
    },
    {
        "word": "outskirts",
        "difficulty": 1142.19,
        "definition": "area relatively far from the center, as of a city or town"
    },
    {
        "word": "bulwark",
        "difficulty": 1142.52,
        "definition": "a protective structure of stone or concrete"
    },
    {
        "word": "swerve",
        "difficulty": 1152.42,
        "definition": "an erratic turn from an intended course"
    },
    {
        "word": "gird",
        "difficulty": 1153.77,
        "definition": "prepare oneself for action or a confrontation"
    },
    {
        "word": "betrothed",
        "difficulty": 1155,
        "definition": "pledged to be married"
    },
    {
        "word": "prospective",
        "difficulty": 1160.55,
        "definition": "of or concerned with or related to the future"
    },
    {
        "word": "advert",
        "difficulty": 1165.12,
        "definition": "make reference to"
    },
    {
        "word": "peremptory",
        "difficulty": 1166.38,
        "definition": "not allowing contradiction or refusal"
    },
    {
        "word": "rudiment",
        "difficulty": 1181.51,
        "definition": "the elementary stage of any subject"
    },
    {
        "word": "deduce",
        "difficulty": 1181.87,
        "definition": "reason from the general to the particular"
    },
    {
        "word": "halting",
        "difficulty": 1191.02,
        "definition": "proceeding in a fragmentary, hesitant, or ineffective way"
    },
    {
        "word": "ignominy",
        "difficulty": 1197.89,
        "definition": "a state of dishonor"
    },
    {
        "word": "ideology",
        "difficulty": 1209.52,
        "definition": "an orientation that characterizes the thinking of a group"
    },
    {
        "word": "pallid",
        "difficulty": 1209.52,
        "definition": "lacking in vitality or interest or effectiveness"
    },
    {
        "word": "chagrin",
        "difficulty": 1222.13,
        "definition": "strong feelings of embarrassment"
    },
    {
        "word": "obtrude",
        "difficulty": 1230.26,
        "definition": "thrust oneself in as if by force"
    },
    {
        "word": "audacious",
        "difficulty": 1243.31,
        "definition": "disposed to venture or take risks"
    },
    {
        "word": "construe",
        "difficulty": 1245.92,
        "definition": "make sense of; assign a meaning to"
    },
    {
        "word": "ford",
        "difficulty": 1250.66,
        "definition": "cross a river where it's shallow"
    },
    {
        "word": "repast",
        "difficulty": 1251.19,
        "definition": "the food served and eaten at one time"
    },
    {
        "word": "stint",
        "difficulty": 1251.19,
        "definition": "an unbroken period of time during which you do something"
    },
    {
        "word": "fresco",
        "difficulty": 1251.46,
        "definition": "a mural done with watercolors on wet plaster"
    },
    {
        "word": "dutiful",
        "difficulty": 1253.71,
        "definition": "willingly obedient out of a sense of respect"
    },
    {
        "word": "hew",
        "difficulty": 1257.04,
        "definition": "make or shape as with an axe"
    },
    {
        "word": "parity",
        "difficulty": 1257.44,
        "definition": "functional equality"
    },
    {
        "word": "affable",
        "difficulty": 1259.98,
        "definition": "diffusing warmth and friendliness"
    },
    {
        "word": "interminable",
        "difficulty": 1282.37,
        "definition": "tiresomely long; seemingly without end"
    },
    {
        "word": "pillage",
        "difficulty": 1283.34,
        "definition": "steal goods; take as spoils"
    },
    {
        "word": "foreboding",
        "difficulty": 1284.45,
        "definition": "a feeling of evil to come"
    },
    {
        "word": "rend",
        "difficulty": 1284.59,
        "definition": "tear or be torn violently"
    },
    {
        "word": "livelihood",
        "difficulty": 1291.88,
        "definition": "the financial means whereby one supports oneself"
    },
    {
        "word": "deign",
        "difficulty": 1299.25,
        "definition": "do something that one considers to be below one's dignity"
    },
    {
        "word": "capricious",
        "difficulty": 1316.6,
        "definition": "determined by chance or impulse rather than by necessity"
    },
    {
        "word": "stupendous",
        "difficulty": 1318.06,
        "definition": "so great in size, force, or extent as to elicit awe"
    },
    {
        "word": "chaff",
        "difficulty": 1318.5,
        "definition": "material consisting of seed coverings and pieces of stem"
    },
    {
        "word": "innate",
        "difficulty": 1325.44,
        "definition": "not established by conditioning or learning"
    },
    {
        "word": "reverie",
        "difficulty": 1330.81,
        "definition": "an abstracted state of absorption"
    },
    {
        "word": "wrangle",
        "difficulty": 1334.86,
        "definition": "quarrel noisily, angrily, or disruptively"
    },
    {
        "word": "crevice",
        "difficulty": 1349.01,
        "definition": "a long narrow opening"
    },
    {
        "word": "ostensible",
        "difficulty": 1349.62,
        "definition": "appearing as such but not necessarily so"
    },
    {
        "word": "craven",
        "difficulty": 1366.6,
        "definition": "lacking even the rudiments of courage; abjectly fearful"
    },
    {
        "word": "vestige",
        "difficulty": 1369.29,
        "definition": "an indication that something has been present"
    },
    {
        "word": "plumb",
        "difficulty": 1369.61,
        "definition": "examine thoroughly and in great depth"
    },
    {
        "word": "reticent",
        "difficulty": 1374.54,
        "definition": "temperamentally disinclined to talk"
    },
    {
        "word": "propensity",
        "difficulty": 1375.98,
        "definition": "an inclination to do something"
    },
    {
        "word": "chide",
        "difficulty": 1379.67,
        "definition": "scold or reprimand severely or angrily"
    },
    {
        "word": "espouse",
        "difficulty": 1387.1,
        "definition": "choose and follow a theory, idea, policy, etc."
    },
    {
        "word": "raiment",
        "difficulty": 1387.92,
        "definition": "especially fine or decorative clothing"
    },
    {
        "word": "intrepid",
        "difficulty": 1387.92,
        "definition": "invulnerable to fear or intimidation"
    },
    {
        "word": "seemly",
        "difficulty": 1403.05,
        "definition": "according with custom or propriety"
    },
    {
        "word": "allay",
        "difficulty": 1403.89,
        "definition": "lessen the intensity of or calm"
    },
    {
        "word": "fitful",
        "difficulty": 1409.07,
        "definition": "occurring in spells and often abruptly"
    },
    {
        "word": "erode",
        "difficulty": 1420.57,
        "definition": "become ground down or deteriorate"
    },
    {
        "word": "unaffected",
        "difficulty": 1426.73,
        "definition": "free of artificiality; sincere and genuine"
    },
    {
        "word": "canto",
        "difficulty": 1437.3,
        "definition": "a major division of a long poem"
    },
    {
        "word": "docile",
        "difficulty": 1452.29,
        "definition": "easily handled or managed"
    },
    {
        "word": "patronize",
        "difficulty": 1453,
        "definition": "treat condescendingly"
    },
    {
        "word": "teem",
        "difficulty": 1456.58,
        "definition": "be full of or abuzz with"
    },
    {
        "word": "estrange",
        "difficulty": 1463.6,
        "definition": "arouse hostility or indifference in"
    },
    {
        "word": "spat",
        "difficulty": 1465.05,
        "definition": "a quarrel about petty points"
    },
    {
        "word": "warble",
        "difficulty": 1466.69,
        "definition": "sing or play with trills"
    },
    {
        "word": "mien",
        "difficulty": 1471.43,
        "definition": "a person's appearance, manner, or demeanor"
    },
    {
        "word": "sate",
        "difficulty": 1490.7,
        "definition": "fill to contentment"
    },
    {
        "word": "constituency",
        "difficulty": 1492.21,
        "definition": "the body of voters who elect a representative for their area"
    },
    {
        "word": "patrician",
        "difficulty": 1492.21,
        "definition": "characteristic of the nobility or aristocracy"
    },
    {
        "word": "parry",
        "difficulty": 1495.79,
        "definition": "avoid or try to avoid fulfilling, answering, or performing"
    },
    {
        "word": "practitioner",
        "difficulty": 1497.68,
        "definition": "someone who carries out a learned profession"
    },
    {
        "word": "ravel",
        "difficulty": 1501.1,
        "definition": "disentangle or separate out"
    },
    {
        "word": "infest",
        "difficulty": 1504.35,
        "definition": "occupy in large numbers or live on a host"
    },
    {
        "word": "actuate",
        "difficulty": 1512.42,
        "definition": "give an incentive for doing something"
    },
    {
        "word": "surly",
        "difficulty": 1518.83,
        "definition": "unfriendly and inclined toward anger or irritation"
    },
    {
        "word": "convalesce",
        "difficulty": 1519.22,
        "definition": "get over an illness or shock"
    },
    {
        "word": "demoralize",
        "difficulty": 1521.36,
        "definition": "lower someone's spirits; make downhearted"
    },
    {
        "word": "devolve",
        "difficulty": 1531.21,
        "definition": "grow worse"
    },
    {
        "word": "alacrity",
        "difficulty": 1532,
        "definition": "liveliness and eagerness"
    },
    {
        "word": "waive",
        "difficulty": 1539.17,
        "definition": "do without or cease to hold or adhere to"
    },
    {
        "word": "unwonted",
        "difficulty": 1543.59,
        "definition": "out of the ordinary"
    },
    {
        "word": "seethe",
        "difficulty": 1543.79,
        "definition": "be in an agitated emotional state"
    },
    {
        "word": "scrutinize",
        "difficulty": 1557.4,
        "definition": "look at critically or searchingly, or in minute detail"
    },
    {
        "word": "diffident",
        "difficulty": 1563.78,
        "definition": "lacking self-confidence"
    },
    {
        "word": "execrate",
        "difficulty": 1566.68,
        "definition": "curse or declare to be evil or anathema"
    },
    {
        "word": "implacable",
        "difficulty": 1576.7,
        "definition": "incapable of being appeased or pacified"
    },
    {
        "word": "pique",
        "difficulty": 1591.54,
        "definition": "a sudden outburst of anger"
    },
    {
        "word": "mite",
        "difficulty": 1599.5,
        "definition": "a slight but appreciable amount"
    },
    {
        "word": "encumber",
        "difficulty": 1607.32,
        "definition": "hold back, impede, or weigh down"
    },
    {
        "word": "uncouth",
        "difficulty": 1612.58,
        "definition": "lacking refinement or cultivation or taste"
    },
    {
        "word": "petulant",
        "difficulty": 1613.24,
        "definition": "easily irritated or annoyed"
    },
    {
        "word": "expiate",
        "difficulty": 1633.95,
        "definition": "make amends for"
    },
    {
        "word": "cavalier",
        "difficulty": 1648.06,
        "definition": "showing a lack of concern or seriousness"
    },
    {
        "word": "banter",
        "difficulty": 1652.9,
        "definition": "light teasing repartee"
    },
    {
        "word": "bluster",
        "difficulty": 1652.9,
        "definition": "act in an arrogant, overly self-assured, or conceited manner"
    },
    {
        "word": "debase",
        "difficulty": 1656.83,
        "definition": "corrupt morally or by intemperance or sensuality"
    },
    {
        "word": "retainer",
        "difficulty": 1656.83,
        "definition": "a person working in the service of another"
    },
    {
        "word": "subjugate",
        "difficulty": 1676.07,
        "definition": "make subservient; force to submit or subdue"
    },
    {
        "word": "extol",
        "difficulty": 1676.31,
        "definition": "praise, glorify, or honor"
    },
    {
        "word": "fraught",
        "difficulty": 1679.64,
        "definition": "filled with or attended with"
    },
    {
        "word": "august",
        "difficulty": 1688.51,
        "definition": "profoundly honored"
    },
    {
        "word": "fissure",
        "difficulty": 1689.71,
        "definition": "a long narrow depression in a surface"
    },
    {
        "word": "knoll",
        "difficulty": 1712.95,
        "definition": "a small natural hill"
    },
    {
        "word": "callous",
        "difficulty": 1717.43,
        "definition": "emotionally hardened"
    },
    {
        "word": "inculcate",
        "difficulty": 1718.17,
        "definition": "teach and impress by difficultyuent repetitions or admonitions"
    },
    {
        "word": "nettle",
        "difficulty": 1725.94,
        "definition": "disturb, especially by minor irritations"
    },
    {
        "word": "blanch",
        "difficulty": 1727.45,
        "definition": "turn pale, as if in fear"
    },
    {
        "word": "inscrutable",
        "difficulty": 1732.01,
        "definition": "difficult or impossible to understand"
    },
    {
        "word": "tenacious",
        "difficulty": 1741.95,
        "definition": "stubbornly unyielding"
    },
    {
        "word": "thrall",
        "difficulty": 1744,
        "definition": "the state of being under the control of another person"
    },
    {
        "word": "exigency",
        "difficulty": 1756.17,
        "definition": "a pressing or urgent situation"
    },
    {
        "word": "disconsolate",
        "difficulty": 1775.94,
        "definition": "sad beyond comforting; incapable of being soothed"
    },
    {
        "word": "impetus",
        "difficulty": 1779.41,
        "definition": "a force that makes something happen"
    },
    {
        "word": "imposition",
        "difficulty": 1784.78,
        "definition": "an uncalled-for burden"
    },
    {
        "word": "auspices",
        "difficulty": 1787.2,
        "definition": "kindly endorsement and guidance"
    },
    {
        "word": "sonorous",
        "difficulty": 1799.71,
        "definition": "full and loud and deep"
    },
    {
        "word": "exploitation",
        "difficulty": 1807.13,
        "definition": "an act that victimizes someone"
    },
    {
        "word": "bane",
        "difficulty": 1815.73,
        "definition": "something causing misery or death"
    },
    {
        "word": "dint",
        "difficulty": 1815.73,
        "definition": "force or effort"
    },
    {
        "word": "ignominious",
        "difficulty": 1823.56,
        "definition": "deserving or bringing disgrace or shame"
    },
    {
        "word": "amicable",
        "difficulty": 1835.73,
        "definition": "characterized by friendship and good will"
    },
    {
        "word": "onset",
        "difficulty": 1840.58,
        "definition": "the beginning or early stages"
    },
    {
        "word": "conservatory",
        "difficulty": 1841.15,
        "definition": "a schoolhouse with special facilities for fine arts"
    },
    {
        "word": "zenith",
        "difficulty": 1862.31,
        "definition": "the highest point of something"
    },
    {
        "word": "voluble",
        "difficulty": 1862.9,
        "definition": "marked by a ready flow of speech"
    },
    {
        "word": "yeoman",
        "difficulty": 1863.78,
        "definition": "a free man who cultivates his own land"
    },
    {
        "word": "levity",
        "difficulty": 1864.07,
        "definition": "a manner lacking seriousness"
    },
    {
        "word": "rapt",
        "difficulty": 1867.31,
        "definition": "feeling great delight and interest"
    },
    {
        "word": "sultry",
        "difficulty": 1876.49,
        "definition": "characterized by oppressive heat and humidity"
    },
    {
        "word": "pinion",
        "difficulty": 1885.46,
        "definition": "restrain or bind"
    },
    {
        "word": "axiom",
        "difficulty": 1886.36,
        "definition": "a proposition that is not susceptible of proof or disproof"
    },
    {
        "word": "descry",
        "difficulty": 1898.77,
        "definition": "catch sight of"
    },
    {
        "word": "retinue",
        "difficulty": 1902.74,
        "definition": "the group following and attending to some important person"
    },
    {
        "word": "functionary",
        "difficulty": 1907.03,
        "definition": "a worker who holds or is invested with an office"
    },
    {
        "word": "imbibe",
        "difficulty": 1915.37,
        "definition": "take in liquids"
    },
    {
        "word": "diversified",
        "difficulty": 1918.16,
        "definition": "having variety of character or form or components"
    },
    {
        "word": "maraud",
        "difficulty": 1919.72,
        "definition": "raid and rove in search of plunder"
    },
    {
        "word": "grudging",
        "difficulty": 1935.1,
        "definition": "petty or reluctant in giving or spending"
    },
    {
        "word": "partiality",
        "difficulty": 1944.65,
        "definition": "a predisposition to like something"
    },
    {
        "word": "philology",
        "difficulty": 1945.61,
        "definition": "the humanistic study of language and literature"
    },
    {
        "word": "wry",
        "difficulty": 2005.97,
        "definition": "humorously sarcastic or mocking"
    },
    {
        "word": "caucus",
        "difficulty": 2007.33,
        "definition": "meet to select a candidate or promote a policy"
    },
    {
        "word": "permeate",
        "difficulty": 2013.14,
        "definition": "spread or diffuse through"
    },
    {
        "word": "propitious",
        "difficulty": 2016.57,
        "definition": "presenting favorable circumstances"
    },
    {
        "word": "salient",
        "difficulty": 2023.82,
        "definition": "conspicuous, prominent, or important"
    },
    {
        "word": "propitiate",
        "difficulty": 2029.37,
        "definition": "make peace with"
    },
    {
        "word": "excise",
        "difficulty": 2037.41,
        "definition": "remove by cutting"
    },
    {
        "word": "betoken",
        "difficulty": 2042.33,
        "definition": "be a signal for or a symptom of"
    },
    {
        "word": "palatable",
        "difficulty": 2043.04,
        "definition": "acceptable to the taste or mind"
    },
    {
        "word": "upbraid",
        "difficulty": 2043.39,
        "definition": "express criticism towards"
    },
    {
        "word": "renegade",
        "difficulty": 2049.41,
        "definition": "someone who rebels and becomes an outlaw"
    },
    {
        "word": "hoary",
        "difficulty": 2064.79,
        "definition": "ancient"
    },
    {
        "word": "pedantic",
        "difficulty": 2101.09,
        "definition": "marked by a narrow focus on or display of learning"
    },
    {
        "word": "coy",
        "difficulty": 2112.72,
        "definition": "showing marked and often playful evasiveness or reluctance"
    },
    {
        "word": "troth",
        "difficulty": 2140.24,
        "definition": "a solemn pledge of fidelity"
    },
    {
        "word": "encroachment",
        "difficulty": 2149.57,
        "definition": "entry to another's property without right or permission"
    },
    {
        "word": "belie",
        "difficulty": 2163.33,
        "definition": "be in contradiction with"
    },
    {
        "word": "armada",
        "difficulty": 2176.07,
        "definition": "a large fleet"
    },
    {
        "word": "succor",
        "difficulty": 2193.01,
        "definition": "assistance in time of difficulty"
    },
    {
        "word": "imperturbable",
        "difficulty": 2194.23,
        "definition": "marked by extreme calm and composure"
    },
    {
        "word": "irresolute",
        "difficulty": 2199.53,
        "definition": "uncertain how to act or proceed"
    },
    {
        "word": "knack",
        "difficulty": 2203.22,
        "definition": "a special way of doing something"
    },
    {
        "word": "unseemly",
        "difficulty": 2209.39,
        "definition": "not in keeping with accepted standards of what is proper"
    },
    {
        "word": "accentuate",
        "difficulty": 2218.51,
        "definition": "stress or single out as important"
    },
    {
        "word": "divulge",
        "difficulty": 2227.28,
        "definition": "make known to the public information previously kept secret"
    },
    {
        "word": "brawn",
        "difficulty": 2239.08,
        "definition": "the trait of possessing muscular strength"
    },
    {
        "word": "burnish",
        "difficulty": 2239.93,
        "definition": "polish and make shiny"
    },
    {
        "word": "palpitate",
        "difficulty": 2251.01,
        "definition": "beat rapidly"
    },
    {
        "word": "promiscuous",
        "difficulty": 2278.32,
        "definition": "not selective of a single class or person"
    },
    {
        "word": "dissemble",
        "difficulty": 2283.6,
        "definition": "make believe with the intent to deceive"
    },
    {
        "word": "flotilla",
        "difficulty": 2287.58,
        "definition": "a fleet of small craft"
    },
    {
        "word": "invective",
        "difficulty": 2300.48,
        "definition": "abusive language used to express blame or censure"
    },
    {
        "word": "hermitage",
        "difficulty": 2309.46,
        "definition": "the abode of a recluse"
    },
    {
        "word": "despoil",
        "difficulty": 2316.24,
        "definition": "destroy and strip of its possession"
    },
    {
        "word": "sully",
        "difficulty": 2357.32,
        "definition": "make dirty or spotty"
    },
    {
        "word": "malevolent",
        "difficulty": 2360.14,
        "definition": "having or exerting a malignant influence"
    },
    {
        "word": "irksome",
        "difficulty": 2365.81,
        "definition": "tedious or irritating"
    },
    {
        "word": "prattle",
        "difficulty": 2371.5,
        "definition": "speak about unimportant matters rapidly and incessantly"
    },
    {
        "word": "subaltern",
        "difficulty": 2379.13,
        "definition": "inferior in rank or status"
    },
    {
        "word": "welt",
        "difficulty": 2388.26,
        "definition": "a raised mark on the skin"
    },
    {
        "word": "wreak",
        "difficulty": 2397.94,
        "definition": "cause to happen or to occur as a consequence"
    },
    {
        "word": "tenable",
        "difficulty": 2400.86,
        "definition": "based on sound reasoning or evidence"
    },
    {
        "word": "inimitable",
        "difficulty": 2413.6,
        "definition": "matchless"
    },
    {
        "word": "depredation",
        "difficulty": 2415.07,
        "definition": "a destructive action"
    },
    {
        "word": "amalgamate",
        "difficulty": 2430.46,
        "definition": "bring or combine together or with something else"
    },
    {
        "word": "immutable",
        "difficulty": 2447.56,
        "definition": "not subject or susceptible to change or variation"
    },
    {
        "word": "proxy",
        "difficulty": 2449.08,
        "definition": "a person authorized to act for another"
    },
    {
        "word": "dote",
        "difficulty": 2450.6,
        "definition": "shower with love; show excessive affection for"
    },
    {
        "word": "reactionary",
        "difficulty": 2457.22,
        "definition": "extremely conservative or resistant to change"
    },
    {
        "word": "rationalism",
        "difficulty": 2461.31,
        "definition": "the doctrine that reason is the basis for regulating conduct"
    },
    {
        "word": "endue",
        "difficulty": 2476.77,
        "definition": "give qualities or abilities to"
    },
    {
        "word": "discriminating",
        "difficulty": 2481.96,
        "definition": "showing or indicating careful judgment and discernment"
    },
    {
        "word": "brooch",
        "difficulty": 2498.74,
        "definition": "a decorative pin"
    },
    {
        "word": "pert",
        "difficulty": 2503.5,
        "definition": "characterized by a lightly saucy or impudent quality"
    },
    {
        "word": "disembark",
        "difficulty": 2504.03,
        "definition": "exit from a ship, vehicle, or aircraft"
    },
    {
        "word": "aria",
        "difficulty": 2528.11,
        "definition": "an elaborate song for solo voice"
    },
    {
        "word": "trappings",
        "difficulty": 2530.82,
        "definition": "ornaments; embellishments to or characteristic signs of"
    },
    {
        "word": "abet",
        "difficulty": 2534.07,
        "definition": "assist or encourage, usually in some wrongdoing"
    },
    {
        "word": "clandestine",
        "difficulty": 2539.51,
        "definition": "conducted with or marked by hidden aims or methods"
    },
    {
        "word": "distend",
        "difficulty": 2543.33,
        "definition": "swell from or as if from internal pressure"
    },
    {
        "word": "glib",
        "difficulty": 2543.88,
        "definition": "having only superficial plausibility"
    },
    {
        "word": "pucker",
        "difficulty": 2548.27,
        "definition": "gather something into small wrinkles or folds"
    },
    {
        "word": "rejoinder",
        "difficulty": 2553.22,
        "definition": "a quick reply to a question or remark"
    },
    {
        "word": "spangle",
        "difficulty": 2554.87,
        "definition": "adornment consisting of a small piece of shiny material"
    },
    {
        "word": "blighted",
        "difficulty": 2568.74,
        "definition": "affected by something that prevents growth or prosperity"
    },
    {
        "word": "nicety",
        "difficulty": 2569.86,
        "definition": "conformity with some standard of correctness or propriety"
    },
    {
        "word": "aggrieve",
        "difficulty": 2590.12,
        "definition": "infringe on the rights of"
    },
    {
        "word": "vestment",
        "difficulty": 2602.65,
        "definition": "a gown worn by the clergy"
    },
    {
        "word": "urbane",
        "difficulty": 2611.27,
        "definition": "showing a high degree of refinement"
    },
    {
        "word": "defray",
        "difficulty": 2631.02,
        "definition": "bear the expenses of"
    },
    {
        "word": "spectral",
        "difficulty": 2670.82,
        "definition": "resembling or characteristic of a phantom"
    },
    {
        "word": "munificent",
        "difficulty": 2673.24,
        "definition": "very generous"
    },
    {
        "word": "dictum",
        "difficulty": 2674.45,
        "definition": "an authoritative declaration"
    },
    {
        "word": "fad",
        "difficulty": 2675.05,
        "definition": "an interest followed with exaggerated zeal"
    },
    {
        "word": "scabbard",
        "difficulty": 2688.43,
        "definition": "a sheath for a sword or dagger or bayonet"
    },
    {
        "word": "adulterate",
        "difficulty": 2689.04,
        "definition": "make impure by adding a foreign or inferior substance"
    },
    {
        "word": "beleaguer",
        "difficulty": 2692.1,
        "definition": "annoy persistently"
    },
    {
        "word": "gripe",
        "difficulty": 2693.33,
        "definition": "complain"
    },
    {
        "word": "remission",
        "difficulty": 2701.32,
        "definition": "an abatement in intensity or degree"
    },
    {
        "word": "exorbitant",
        "difficulty": 2706.89,
        "definition": "greatly exceeding bounds of reason or moderation"
    },
    {
        "word": "invocation",
        "difficulty": 2710.61,
        "definition": "the act of appealing for help"
    },
    {
        "word": "cajole",
        "difficulty": 2719.33,
        "definition": "influence or urge by gentle urging, caressing, or flattering"
    },
    {
        "word": "inclusive",
        "difficulty": 2756.08,
        "definition": "encompassing much or everything"
    },
    {
        "word": "interdict",
        "difficulty": 2767.05,
        "definition": "command against"
    },
    {
        "word": "abase",
        "difficulty": 2768.34,
        "definition": "cause to feel shame"
    },
    {
        "word": "obviate",
        "difficulty": 2798.47,
        "definition": "do away with"
    },
    {
        "word": "hurtle",
        "difficulty": 2799.79,
        "definition": "move with or as if with a rushing sound"
    },
    {
        "word": "unanimity",
        "difficulty": 2801.78,
        "definition": "everyone being of one mind"
    },
    {
        "word": "mettle",
        "difficulty": 2804.44,
        "definition": "the courage to carry on"
    },
    {
        "word": "interpolate",
        "difficulty": 2810.44,
        "definition": "insert words into texts, often falsifying it thereby"
    },
    {
        "word": "surreptitious",
        "difficulty": 2813.78,
        "definition": "marked by quiet and caution and secrecy"
    },
    {
        "word": "dissimulate",
        "difficulty": 2814.45,
        "definition": "hide feelings from other people"
    },
    {
        "word": "ruse",
        "difficulty": 2815.12,
        "definition": "a deceptive maneuver, especially to avoid capture"
    },
    {
        "word": "specious",
        "difficulty": 2838.09,
        "definition": "plausible but false"
    },
    {
        "word": "revulsion",
        "difficulty": 2845.6,
        "definition": "intense aversion"
    },
    {
        "word": "hale",
        "difficulty": 2854.53,
        "definition": "exhibiting or restored to vigorous good health"
    },
    {
        "word": "palliate",
        "difficulty": 2871.86,
        "definition": "lessen or to try to lessen the seriousness or extent of"
    },
    {
        "word": "obtuse",
        "difficulty": 2876.05,
        "definition": "lacking in insight or discernment"
    },
    {
        "word": "querulous",
        "difficulty": 2885.17,
        "definition": "habitually complaining"
    },
    {
        "word": "vagary",
        "difficulty": 2887.28,
        "definition": "an unexpected and inexplicable change in something"
    },
    {
        "word": "incipient",
        "difficulty": 2890.1,
        "definition": "only partly in existence; imperfectly formed"
    },
    {
        "word": "obdurate",
        "difficulty": 2891.51,
        "definition": "stubbornly persistent in wrongdoing"
    },
    {
        "word": "grovel",
        "difficulty": 2912.88,
        "definition": "show submission or fear"
    },
    {
        "word": "refractory",
        "difficulty": 2923.68,
        "definition": "stubbornly resistant to authority or control"
    },
    {
        "word": "dregs",
        "difficulty": 2944.06,
        "definition": "sediment that has settled at the bottom of a liquid"
    },
    {
        "word": "ascendancy",
        "difficulty": 2944.06,
        "definition": "the state when one person or group has power over another"
    },
    {
        "word": "supercilious",
        "difficulty": 2946.99,
        "definition": "having or showing arrogant disdain or haughtiness"
    },
    {
        "word": "pundit",
        "difficulty": 2961.01,
        "definition": "someone who has been admitted to membership in a field"
    },
    {
        "word": "commiserate",
        "difficulty": 2973.66,
        "definition": "feel or express sympathy or compassion"
    },
    {
        "word": "alcove",
        "difficulty": 2974.41,
        "definition": "a small recess opening off a larger room"
    },
    {
        "word": "assay",
        "difficulty": 2977.41,
        "definition": "make an effort or attempt"
    },
    {
        "word": "parochial",
        "difficulty": 2906.44,
        "definition": "narrowly restricted in outlook or scope"
    },
    {
        "word": "conjugal",
        "difficulty": 2999.3,
        "definition": "relating to the relationship between a wife and husband"
    },
    {
        "word": "abjure",
        "difficulty": 3003.11,
        "definition": "formally reject or disavow a formerly held belief"
    },
    {
        "word": "frieze",
        "difficulty": 3008.46,
        "definition": "an ornament consisting of a horizontal sculptured band"
    },
    {
        "word": "ornate",
        "difficulty": 3016.9,
        "definition": "marked by complexity and richness of detail"
    },
    {
        "word": "inflammatory",
        "difficulty": 3019.98,
        "definition": "arousing to action or rebellion"
    },
    {
        "word": "machination",
        "difficulty": 3026.94,
        "definition": "a crafty and involved plot to achieve your ends"
    },
    {
        "word": "mendicant",
        "difficulty": 3028.49,
        "definition": "a pauper who lives by begging"
    },
    {
        "word": "meander",
        "difficulty": 3045.64,
        "definition": "move or cause to move in a winding or curving course"
    },
    {
        "word": "bullion",
        "difficulty": 3045.64,
        "definition": "gold or silver in bars or ingots"
    },
    {
        "word": "diffidence",
        "difficulty": 3046.43,
        "definition": "lack of self-assurance"
    },
    {
        "word": "makeshift",
        "difficulty": 3048,
        "definition": "done or made using whatever is available"
    },
    {
        "word": "husbandry",
        "difficulty": 3053.51,
        "definition": "the practice of cultivating the land or raising stock"
    },
    {
        "word": "podium",
        "difficulty": 3058.25,
        "definition": "a platform raised above the surrounding level"
    },
    {
        "word": "dearth",
        "difficulty": 3059.04,
        "definition": "an insufficient quantity or number"
    },
    {
        "word": "granary",
        "difficulty": 3065.38,
        "definition": "a storehouse for threshed grain or animal feed"
    },
    {
        "word": "whet",
        "difficulty": 3073.34,
        "definition": "make keen or more acute"
    },
    {
        "word": "imposture",
        "difficulty": 3077.34,
        "definition": "pretending to be another person"
    },
    {
        "word": "diadem",
        "difficulty": 3079.75,
        "definition": "an ornamental jeweled headdress signifying sovereignty"
    },
    {
        "word": "fallow",
        "difficulty": 3081.35,
        "definition": "undeveloped but potentially useful"
    },
    {
        "word": "hubbub",
        "difficulty": 3117.91,
        "definition": "loud confused noise from many sources"
    },
    {
        "word": "dispassionate",
        "difficulty": 3120.37,
        "definition": "unaffected by strong emotion or prejudice"
    },
    {
        "word": "harrowing",
        "difficulty": 3126.97,
        "definition": "causing extreme distress"
    },
    {
        "word": "askance",
        "difficulty": 3136.1,
        "definition": "with suspicion or disapproval"
    },
    {
        "word": "lancet",
        "difficulty": 3162.09,
        "definition": "a surgical knife with a pointed double-edged blade"
    },
    {
        "word": "rankle",
        "difficulty": 3168.02,
        "definition": "make resentful or angry"
    },
    {
        "word": "ramify",
        "difficulty": 3168.87,
        "definition": "have or develop complicating consequences"
    },
    {
        "word": "gainsay",
        "difficulty": 3172.27,
        "definition": "take exception to"
    },
    {
        "word": "polity",
        "difficulty": 3194.55,
        "definition": "a governmentally organized unit"
    },
    {
        "word": "credence",
        "difficulty": 3196.27,
        "definition": "the mental attitude that something is believable"
    },
    {
        "word": "indemnify",
        "difficulty": 3204.07,
        "definition": "make amends for; pay compensation for"
    },
    {
        "word": "ingratiate",
        "difficulty": 3213.64,
        "definition": "gain favor with somebody by deliberate efforts"
    },
    {
        "word": "declivity",
        "difficulty": 3222.4,
        "definition": "a downward slope or bend"
    },
    {
        "word": "importunate",
        "difficulty": 3228.56,
        "definition": "making persistent or urgent requests"
    },
    {
        "word": "passe",
        "difficulty": 3242.72,
        "definition": "out of fashion"
    },
    {
        "word": "whittle",
        "difficulty": 3248.06,
        "definition": "cut small bits or pare shavings from"
    },
    {
        "word": "repine",
        "difficulty": 3268.71,
        "definition": "express discontent"
    },
    {
        "word": "flay",
        "difficulty": 3274.14,
        "definition": "strip the skin off"
    },
    {
        "word": "larder",
        "difficulty": 3284.14,
        "definition": "a small storeroom for storing foods or wines"
    },
    {
        "word": "threadbare",
        "difficulty": 3286.88,
        "definition": "thin and tattered with age"
    },
    {
        "word": "grisly",
        "difficulty": 3296.04,
        "definition": "shockingly repellent; inspiring horror"
    },
    {
        "word": "untoward",
        "difficulty": 3306.18,
        "definition": "not in keeping with accepted standards of what is proper"
    },
    {
        "word": "idiosyncrasy",
        "difficulty": 3312.66,
        "definition": "a behavioral attribute peculiar to an individual"
    },
    {
        "word": "quip",
        "difficulty": 3314.52,
        "definition": "make jokes or witty remarks"
    },
    {
        "word": "blatant",
        "difficulty": 3325.7,
        "definition": "without any attempt at concealment; completely obvious"
    },
    {
        "word": "stanch",
        "difficulty": 3354.95,
        "definition": "stop the flow of a liquid"
    },
    {
        "word": "incongruity",
        "difficulty": 3365.45,
        "definition": "the quality of disagreeing"
    },
    {
        "word": "perfidious",
        "difficulty": 3367.37,
        "definition": "tending to betray"
    },
    {
        "word": "platitude",
        "difficulty": 3370.24,
        "definition": "a trite or obvious remark"
    },
    {
        "word": "revelry",
        "difficulty": 3374.09,
        "definition": "unrestrained merrymaking"
    },
    {
        "word": "delve",
        "difficulty": 3380.84,
        "definition": "turn up, loosen, or remove earth"
    },
    {
        "word": "extenuate",
        "difficulty": 3386.65,
        "definition": "lessen or to try to lessen the seriousness or degree of"
    },
    {
        "word": "polemic",
        "difficulty": 3391.51,
        "definition": "a verbal or written attack, especially of a belief or dogma"
    },
    {
        "word": "enrapture",
        "difficulty": 3396.38,
        "definition": "hold spellbound"
    },
    {
        "word": "virtuoso",
        "difficulty": 3403.22,
        "definition": "someone who is dazzlingly skilled in any field"
    },
    {
        "word": "glower",
        "difficulty": 3404.2,
        "definition": "look angry or sullen as if to signal disapproval"
    },
    {
        "word": "mundane",
        "difficulty": 3411.07,
        "definition": "found in the ordinary course of events"
    },
    {
        "word": "fatuous",
        "difficulty": 3416.99,
        "definition": "devoid of intelligence"
    },
    {
        "word": "incorrigible",
        "difficulty": 3417.97,
        "definition": "impervious to correction by punishment"
    },
    {
        "word": "postulate",
        "difficulty": 3420.94,
        "definition": "maintain or assert"
    },
    {
        "word": "gist",
        "difficulty": 3440.85,
        "definition": "the central meaning or theme of a speech or literary work"
    },
    {
        "word": "vociferous",
        "difficulty": 3451.89,
        "definition": "conspicuously and offensively loud"
    },
    {
        "word": "purvey",
        "difficulty": 3466.06,
        "definition": "supply with provisions"
    },
    {
        "word": "baleful",
        "difficulty": 3466.06,
        "definition": "deadly or sinister"
    },
    {
        "word": "gibe",
        "difficulty": 3472.16,
        "definition": "laugh at with contempt and derision"
    },
    {
        "word": "dyspeptic",
        "difficulty": 3473.18,
        "definition": "irritable as if suffering from indigestion"
    },
    {
        "word": "prude",
        "difficulty": 3475.22,
        "definition": "a person excessively concerned about propriety and decorum"
    },
    {
        "word": "luminary",
        "difficulty": 3477.27,
        "definition": "a celebrity who is an inspiration to others"
    },
    {
        "word": "amenable",
        "difficulty": 3480.34,
        "definition": "disposed or willing to comply"
    },
    {
        "word": "willful",
        "difficulty": 3493.7,
        "definition": "habitually disposed to disobedience and opposition"
    },
    {
        "word": "overbearing",
        "difficulty": 3504.06,
        "definition": "having or showing arrogant superiority to"
    },
    {
        "word": "dais",
        "difficulty": 3514.47,
        "definition": "a platform raised above the surrounding level"
    },
    {
        "word": "automate",
        "difficulty": 3516.56,
        "definition": "operate or make run by machines rather than human action"
    },
    {
        "word": "enervate",
        "difficulty": 3523.89,
        "definition": "weaken physically, mentally, or morally"
    },
    {
        "word": "wheedle",
        "difficulty": 3530.21,
        "definition": "influence or urge by gentle urging, caressing, or flattering"
    },
    {
        "word": "gusto",
        "difficulty": 3549.28,
        "definition": "vigorous and enthusiastic enjoyment"
    },
    {
        "word": "bouillon",
        "difficulty": 3551.41,
        "definition": "a clear seasoned broth"
    },
    {
        "word": "omniscient",
        "difficulty": 3562.11,
        "definition": "knowing, seeing, or understanding everything"
    },
    {
        "word": "apostate",
        "difficulty": 3579.36,
        "definition": "not faithful to religion or party or cause"
    },
    {
        "word": "carrion",
        "difficulty": 3589.13,
        "definition": "the dead and rotting body of an animal; unfit for human food"
    },
    {
        "word": "emolument",
        "difficulty": 3601.16,
        "definition": "compensation received by virtue of holding an office"
    },
    {
        "word": "ungainly",
        "difficulty": 3603.35,
        "definition": "lacking grace in movement or posture"
    },
    {
        "word": "impiety",
        "difficulty": 3634.36,
        "definition": "unrighteousness by virtue of lacking respect for a god"
    },
    {
        "word": "decadence",
        "difficulty": 3636.59,
        "definition": "the state of being degenerate in mental or moral qualities"
    },
    {
        "word": "homily",
        "difficulty": 3642.19,
        "definition": "a sermon on a moral or religious topic"
    },
    {
        "word": "avocation",
        "difficulty": 3657.96,
        "definition": "an auxiliary activity"
    },
    {
        "word": "circumvent",
        "difficulty": 3692.23,
        "definition": "avoid or try to avoid fulfilling, answering, or performing"
    },
    {
        "word": "syllogism",
        "difficulty": 3695.69,
        "definition": "reasoning in which a conclusion is derived from two premises"
    },
    {
        "word": "collation",
        "difficulty": 3718.93,
        "definition": "assembling in proper numerical or logical sequence"
    },
    {
        "word": "haggle",
        "difficulty": 3721.27,
        "definition": "wrangle, as over a price or terms of an agreement"
    },
    {
        "word": "waylay",
        "difficulty": 3728.31,
        "definition": "wait in hiding to attack"
    },
    {
        "word": "savant",
        "difficulty": 3731.84,
        "definition": "a learned person"
    },
    {
        "word": "cohort",
        "difficulty": 3733.02,
        "definition": "a group of people having approximately the same age"
    },
    {
        "word": "unction",
        "difficulty": 3736.56,
        "definition": "excessive but superficial compliments with affected charm"
    },
    {
        "word": "adjure",
        "difficulty": 3740.1,
        "definition": "command solemnly"
    },
    {
        "word": "acrimony",
        "difficulty": 3742.47,
        "definition": "a rough and bitter manner"
    },
    {
        "word": "clarion",
        "difficulty": 3744.84,
        "definition": "loud and clear"
    },
    {
        "word": "turbid",
        "difficulty": 3753.16,
        "definition": "clouded as with sediment"
    },
    {
        "word": "cupidity",
        "difficulty": 3756.74,
        "definition": "extreme greed for material wealth"
    },
    {
        "word": "disaffected",
        "difficulty": 3766.31,
        "definition": "discontented as toward authority"
    },
    {
        "word": "preternatural",
        "difficulty": 3767.51,
        "definition": "surpassing the ordinary or normal"
    },
    {
        "word": "eschew",
        "difficulty": 3772.32,
        "definition": "avoid and stay away from deliberately"
    },
    {
        "word": "expatiate",
        "difficulty": 3779.55,
        "definition": "add details, as to an account or idea"
    },
    {
        "word": "didactic",
        "difficulty": 3784.39,
        "definition": "instructive, especially excessively"
    },
    {
        "word": "sinuous",
        "difficulty": 3788.03,
        "definition": "curved or curving in and out"
    },
    {
        "word": "rancor",
        "difficulty": 3788.03,
        "definition": "a feeling of deep and bitter anger and ill-will"
    },
    {
        "word": "puissant",
        "difficulty": 3794.1,
        "definition": "powerful"
    },
    {
        "word": "homespun",
        "difficulty": 3801.42,
        "definition": "characteristic of country life"
    },
    {
        "word": "embroil",
        "difficulty": 3845.93,
        "definition": "force into some kind of situation or course of action"
    },
    {
        "word": "pathological",
        "difficulty": 3848.43,
        "definition": "caused by or evidencing a mentally disturbed condition"
    },
    {
        "word": "resonant",
        "difficulty": 2023.82,
        "definition": "characterized by a loud deep sound"
    },
    {
        "word": "libretto",
        "difficulty": 3877.45,
        "definition": "the words of an opera or musical play"
    },
    {
        "word": "flail",
        "difficulty": 3886.38,
        "definition": "thrash about"
    },
    {
        "word": "bandy",
        "difficulty": 3888.93,
        "definition": "discuss lightly"
    },
    {
        "word": "gratis",
        "difficulty": 3906.92,
        "definition": "costing nothing"
    },
    {
        "word": "upshot",
        "difficulty": 3912.09,
        "definition": "a phenomenon that is caused by some previous phenomenon"
    },
    {
        "word": "aphorism",
        "difficulty": 3918.57,
        "definition": "a short pithy instructive saying"
    },
    {
        "word": "redoubtable",
        "difficulty": 3922.47,
        "definition": "worthy of respect or honor"
    },
    {
        "word": "corpulent",
        "difficulty": 3951.3,
        "definition": "excessively fat"
    },
    {
        "word": "benighted",
        "difficulty": 3965.88,
        "definition": "lacking enlightenment or knowledge or culture"
    },
    {
        "word": "sententious",
        "difficulty": 3968.54,
        "definition": "abounding in or given to pompous or aphoristic moralizing"
    },
    {
        "word": "cabal",
        "difficulty": 3013.82,
        "definition": "a clique that seeks power usually through intrigue"
    },
    {
        "word": "paraphernalia",
        "difficulty": 3994.01,
        "definition": "equipment consisting of miscellaneous articles"
    },
    {
        "word": "vitiate",
        "difficulty": 4008.9,
        "definition": "make imperfect"
    },
    {
        "word": "adulation",
        "difficulty": 4008.9,
        "definition": "exaggerated flattery or praise"
    },
    {
        "word": "quaff",
        "difficulty": 4019.81,
        "definition": "swallow hurriedly or greedily or in one draught"
    },
    {
        "word": "unassuming",
        "difficulty": 4019.81,
        "definition": "not arrogant"
    },
    {
        "word": "libertine",
        "difficulty": 4026.65,
        "definition": "a dissolute person"
    },
    {
        "word": "maul",
        "difficulty": 4033.52,
        "definition": "injure badly"
    },
    {
        "word": "adage",
        "difficulty": 4039.03,
        "definition": "a condensed but memorable saying embodying an important fact"
    },
    {
        "word": "expostulation",
        "difficulty": 4040.41,
        "definition": "the act of expressing earnest opposition or protest"
    },
    {
        "word": "tawdry",
        "difficulty": 4048.71,
        "definition": "tastelessly showy"
    },
    {
        "word": "trite",
        "difficulty": 4050.1,
        "definition": "repeated too often; overfamiliar through overuse"
    },
    {
        "word": "hireling",
        "difficulty": 4052.87,
        "definition": "a person who works only for money"
    },
    {
        "word": "ensconce",
        "difficulty": 4057.04,
        "definition": "fix firmly"
    },
    {
        "word": "egregious",
        "difficulty": 4086.49,
        "definition": "conspicuously and outrageously bad or reprehensible"
    },
    {
        "word": "cogent",
        "difficulty": 4099.24,
        "definition": "powerfully persuasive"
    },
    {
        "word": "incisive",
        "difficulty": 4100.66,
        "definition": "demonstrating ability to recognize or draw fine distinctions"
    },
    {
        "word": "errant",
        "difficulty": 4102.08,
        "definition": "straying from the right course or from accepted standards"
    },
    {
        "word": "sedulous",
        "difficulty": 4112.06,
        "definition": "marked by care and persistent effort"
    },
    {
        "word": "incandescent",
        "difficulty": 4122.1,
        "definition": "characterized by ardent emotion, intensity, or brilliance"
    },
    {
        "word": "derelict",
        "difficulty": 4124.97,
        "definition": "in deplorable condition"
    },
    {
        "word": "entomology",
        "difficulty": 4153.96,
        "definition": "the branch of zoology that studies insects"
    },
    {
        "word": "execrable",
        "difficulty": 4164.2,
        "definition": "unequivocally detestable"
    },
    {
        "word": "sluice",
        "difficulty": 4168.6,
        "definition": "pour as if from a conduit that carries a rapid flow of water"
    },
    {
        "word": "moot",
        "difficulty": 4170.07,
        "definition": "of no legal significance, as having been previously decided"
    },
    {
        "word": "evanescent",
        "difficulty": 4171.54,
        "definition": "short-lived; tending to vanish or disappear"
    },
    {
        "word": "vat",
        "difficulty": 4187.79,
        "definition": "a large open vessel for holding or storing liquids"
    },
    {
        "word": "dapper",
        "difficulty": 4207.16,
        "definition": "marked by up-to-dateness in dress and manners"
    },
    {
        "word": "asperity",
        "difficulty": 4217.66,
        "definition": "harshness of manner"
    },
    {
        "word": "flair",
        "difficulty": 4225.2,
        "definition": "a natural talent"
    },
    {
        "word": "mote",
        "difficulty": 4226.71,
        "definition": "a tiny piece of anything"
    },
    {
        "word": "circumspect",
        "difficulty": 4243.39,
        "definition": "careful to consider potential consequences and avoid risk"
    },
    {
        "word": "inimical",
        "difficulty": 4274.07,
        "definition": "not friendly"
    },
    {
        "word": "apropos",
        "difficulty": 4284.91,
        "definition": "of a suitable, fitting, or pertinent nature"
    },
    {
        "word": "gruel",
        "difficulty": 4284.91,
        "definition": "a thin porridge"
    },
    {
        "word": "gentility",
        "difficulty": 4289.57,
        "definition": "elegance by virtue of fineness of manner and expression"
    },
    {
        "word": "disapprobation",
        "difficulty": 4338.36,
        "definition": "pronouncing as wrong or morally culpable"
    },
    {
        "word": "cameo",
        "difficulty": 4349.53,
        "definition": "engraving or carving in low relief on a stone"
    },
    {
        "word": "gouge",
        "difficulty": 4355.94,
        "definition": "swindle; obtain by coercion"
    },
    {
        "word": "oratorio",
        "difficulty": 4370.43,
        "definition": "a musical composition for voices and orchestra"
    },
    {
        "word": "inclement",
        "difficulty": 4383.39,
        "definition": "severe, of weather"
    },
    {
        "word": "scintilla",
        "difficulty": 4406.26,
        "definition": "a tiny or scarcely detectable amount"
    },
    {
        "word": "confluence",
        "difficulty": 4429.37,
        "definition": "a flowing together"
    },
    {
        "word": "squalor",
        "difficulty": 4439.34,
        "definition": "sordid dirtiness"
    },
    {
        "word": "stricture",
        "difficulty": 4451.04,
        "definition": "severe criticism"
    },
    {
        "word": "emblazon",
        "difficulty": 4479.71,
        "definition": "decorate with heraldic arms"
    },
    {
        "word": "augury",
        "difficulty": 4479.71,
        "definition": "an event indicating important things to come"
    },
    {
        "word": "abut",
        "difficulty": 4500.17,
        "definition": "lie adjacent to another or share a boundary"
    },
    {
        "word": "banal",
        "difficulty": 4510.47,
        "definition": "repeated too often; overfamiliar through overuse"
    },
    {
        "word": "congeal",
        "difficulty": 4513.91,
        "definition": "solidify, thicken, or come together"
    },
    {
        "word": "pilfer",
        "difficulty": 4567.97,
        "definition": "make off with belongings of others"
    },
    {
        "word": "malcontent",
        "difficulty": 4571.5,
        "definition": "a person who is unsatisfied or disgusted"
    },
    {
        "word": "sublimate",
        "difficulty": 4571.5,
        "definition": "direct energy or urges into useful activities"
    },
    {
        "word": "eugenic",
        "difficulty": 4592.81,
        "definition": "causing improvement in the offspring produced"
    },
    {
        "word": "lineament",
        "difficulty": 4603.54,
        "definition": "the characteristic parts of a person's face"
    },
    {
        "word": "firebrand",
        "difficulty": 4610.72,
        "definition": "someone who deliberately foments trouble"
    },
    {
        "word": "fiasco",
        "difficulty": 4628.76,
        "definition": "a complete failure or collapse"
    },
    {
        "word": "foolhardy",
        "difficulty": 4634.21,
        "definition": "marked by defiant disregard for danger or consequences"
    },
    {
        "word": "retrench",
        "difficulty": 4652.44,
        "definition": "tighten one's belt; use resources carefully"
    },
    {
        "word": "ulterior",
        "difficulty": 4659.77,
        "definition": "lying beyond what is openly revealed or avowed"
    },
    {
        "word": "equable",
        "difficulty": 4663.45,
        "definition": "not varying"
    },
    {
        "word": "inured",
        "difficulty": 4702.4,
        "definition": "made tough by habitual exposure"
    },
    {
        "word": "invidious",
        "difficulty": 4702.4,
        "definition": "containing or implying a slight or showing prejudice"
    },
    {
        "word": "unmitigated",
        "difficulty": 4709.89,
        "definition": "not diminished or moderated in intensity or severity"
    },
    {
        "word": "concomitant",
        "difficulty": 4766.85,
        "definition": "an event or situation that happens at the same time"
    },
    {
        "word": "cozen",
        "difficulty": 4805.6,
        "definition": "cheat or trick"
    },
    {
        "word": "phlegmatic",
        "difficulty": 4823.24,
        "definition": "showing little emotion"
    },
    {
        "word": "dormer",
        "difficulty": 4825.21,
        "definition": "a gabled extension built out from a sloping roof"
    },
    {
        "word": "pontifical",
        "difficulty": 4837.05,
        "definition": "denoting or governed by or relating to a bishop or bishops"
    },
    {
        "word": "disport",
        "difficulty": 4837.05,
        "definition": "occupy in an agreeable, entertaining or pleasant fashion"
    },
    {
        "word": "apologist",
        "difficulty": 4854.93,
        "definition": "a person who argues to defend some policy or institution"
    },
    {
        "word": "abeyance",
        "difficulty": 4862.91,
        "definition": "temporary cessation or suspension"
    },
    {
        "word": "enclave",
        "difficulty": 4880.98,
        "definition": "an enclosed territory that is culturally distinct"
    },
    {
        "word": "improvident",
        "difficulty": 4899.18,
        "definition": "not supplying something useful for the future"
    },
    {
        "word": "disquisition",
        "difficulty": 4913.43,
        "definition": "an elaborate analytical or explanatory essay or discussion"
    },
    {
        "word": "categorical",
        "difficulty": 4917.52,
        "definition": "not modified or restricted by reservations"
    },
    {
        "word": "placate",
        "difficulty": 1133.44,
        "definition": "cause to be more favorably inclined"
    },
    {
        "word": "redolent",
        "difficulty": 4927.77,
        "definition": "serving to bring to mind"
    },
    {
        "word": "felicitous",
        "difficulty": 4948.39,
        "definition": "exhibiting an agreeably appropriate manner or style"
    },
    {
        "word": "gusty",
        "difficulty": 4954.61,
        "definition": "blowing in puffs or short intermittent blasts"
    },
    {
        "word": "natty",
        "difficulty": 4962.93,
        "definition": "marked by up-to-dateness in dress and manners"
    },
    {
        "word": "pacifist",
        "difficulty": 4965.01,
        "definition": "opposed to war"
    },
    {
        "word": "buxom",
        "difficulty": 4975.46,
        "definition": "healthily plump and vigorous"
    },
    {
        "word": "heyday",
        "difficulty": 4988.05,
        "definition": "the period of greatest prosperity or productivity"
    },
    {
        "word": "herculean",
        "difficulty": 5004.94,
        "definition": "displaying superhuman strength or power"
    },
    {
        "word": "burgeon",
        "difficulty": 5041.22,
        "definition": "grow and flourish"
    },
    {
        "word": "crone",
        "difficulty": 5086.76,
        "definition": "an ugly, evil-looking old woman"
    },
    {
        "word": "prognosticate",
        "difficulty": 5106.53,
        "definition": "make a prediction about; tell in advance"
    },
    {
        "word": "lout",
        "difficulty": 5117.58,
        "definition": "an awkward stupid person"
    },
    {
        "word": "simper",
        "difficulty": 5126.46,
        "definition": "smile in an insincere, unnatural, or coy way"
    },
    {
        "word": "iniquitous",
        "difficulty": 5128.68,
        "definition": "characterized by injustice or wickedness"
    },
    {
        "word": "rile",
        "difficulty": 5146.54,
        "definition": "disturb, especially by minor irritations"
    },
    {
        "word": "sentient",
        "difficulty": 5160.02,
        "definition": "endowed with feeling and unstructured consciousness"
    },
    {
        "word": "garish",
        "difficulty": 5198.59,
        "definition": "tastelessly showy"
    },
    {
        "word": "readjustment",
        "difficulty": 5200.87,
        "definition": "the act of correcting again"
    },
    {
        "word": "erstwhile",
        "difficulty": 5235.42,
        "definition": "belonging to some prior time"
    },
    {
        "word": "aquiline",
        "difficulty": 5251.69,
        "definition": "curved down like an eagle's beak"
    },
    {
        "word": "bilious",
        "difficulty": 5261.04,
        "definition": "irritable as if suffering from indigestion"
    },
    {
        "word": "vilify",
        "difficulty": 5277.48,
        "definition": "spread negative information about"
    },
    {
        "word": "nuance",
        "difficulty": 5289.28,
        "definition": "a subtle difference in meaning or opinion or attitude"
    },
    {
        "word": "gawk",
        "difficulty": 5322.62,
        "definition": "look with amazement"
    },
    {
        "word": "refectory",
        "difficulty": 5327.41,
        "definition": "a communal dining-hall, usually in a monastery"
    },
    {
        "word": "palatial",
        "difficulty": 5339.44,
        "definition": "suitable for or like a large and stately residence"
    },
    {
        "word": "mincing",
        "difficulty": 5344.27,
        "definition": "affectedly dainty or refined"
    },
    {
        "word": "trenchant",
        "difficulty": 5400.41,
        "definition": "having keenness and forcefulness and penetration in thought"
    },
    {
        "word": "emboss",
        "difficulty": 5407.82,
        "definition": "raise in a relief"
    },
    {
        "word": "proletarian",
        "difficulty": 5410.3,
        "definition": "a member of the working class"
    },
    {
        "word": "careen",
        "difficulty": 5420.22,
        "definition": "pitching dangerously to one side"
    },
    {
        "word": "debacle",
        "difficulty": 5420.22,
        "definition": "a sound defeat"
    },
    {
        "word": "sycophant",
        "difficulty": 5425.19,
        "definition": "a person who tries to please someone to gain an advantage"
    },
    {
        "word": "crabbed",
        "difficulty": 5437.67,
        "definition": "annoyed and irritable"
    },
    {
        "word": "archetype",
        "difficulty": 5457.75,
        "definition": "something that serves as a model"
    },
    {
        "word": "cryptic",
        "difficulty": 5477.97,
        "definition": "of an obscure nature"
    },
    {
        "word": "penchant",
        "difficulty": 5485.6,
        "definition": "a strong liking or preference"
    },
    {
        "word": "bauble",
        "difficulty": 5488.15,
        "definition": "cheap showy jewelry or ornament"
    },
    {
        "word": "mountebank",
        "difficulty": 5493.24,
        "definition": "a flamboyant deceiver"
    },
    {
        "word": "fawning",
        "difficulty": 5518.89,
        "definition": "attempting to win favor by flattery"
    },
    {
        "word": "hummock",
        "difficulty": 5555.19,
        "definition": "a small natural hill"
    },
    {
        "word": "apotheosis",
        "difficulty": 5573.52,
        "definition": "model of excellence or perfection of a kind"
    },
    {
        "word": "discretionary",
        "difficulty": 5584.05,
        "definition": "not earmarked; available for use as needed"
    },
    {
        "word": "pithy",
        "difficulty": 5634.61,
        "definition": "concise and full of meaning"
    },
    {
        "word": "comport",
        "difficulty": 5634.61,
        "definition": "behave in a certain manner"
    },
    {
        "word": "checkered",
        "difficulty": 5637.3,
        "definition": "marked by changeable fortune"
    },
    {
        "word": "ambrosia",
        "difficulty": 5639.98,
        "definition": "the food and drink of the gods"
    },
    {
        "word": "factious",
        "difficulty": 5677.9,
        "definition": "dissenting with the majority opinion"
    },
    {
        "word": "disgorge",
        "difficulty": 5680.63,
        "definition": "cause or allow to flow or run out or over"
    },
    {
        "word": "filch",
        "difficulty": 5749.69,
        "definition": "make off with belongings of others"
    },
    {
        "word": "wraith",
        "difficulty": 5783.44,
        "definition": "a ghostly figure, especially one seen shortly before death"
    },
    {
        "word": "demonstrable",
        "difficulty": 5789.11,
        "definition": "capable of being proved"
    },
    {
        "word": "pertinacious",
        "difficulty": 5826.19,
        "definition": "stubbornly unyielding"
    },
    {
        "word": "emend",
        "difficulty": 5855.04,
        "definition": "make corrections to"
    },
    {
        "word": "laggard",
        "difficulty": 5890.04,
        "definition": "someone who takes more time than necessary"
    },
    {
        "word": "waffle",
        "difficulty": 5895.92,
        "definition": "pause or hold back in uncertainty or unwillingness"
    },
    {
        "word": "loquacious",
        "difficulty": 5895.92,
        "definition": "full of trivial conversation"
    },
    {
        "word": "venial",
        "difficulty": 5922.5,
        "definition": "easily excused or forgiven"
    },
    {
        "word": "peon",
        "difficulty": 5952.31,
        "definition": "a laborer who is obliged to do menial work"
    },
    {
        "word": "effulgence",
        "difficulty": 5985.46,
        "definition": "the quality of being bright and sending out rays of light"
    },
    {
        "word": "lode",
        "difficulty": 6003.7,
        "definition": "a deposit of valuable ore"
    },
    {
        "word": "fanfare",
        "difficulty": 6009.8,
        "definition": "a gaudy outward display"
    },
    {
        "word": "dilettante",
        "difficulty": 6015.92,
        "definition": "showing frivolous or superficial interest; amateurish"
    },
    {
        "word": "pusillanimous",
        "difficulty": 6028.19,
        "definition": "lacking in courage, strength, and resolution"
    },
    {
        "word": "ingrained",
        "difficulty": 6034.34,
        "definition": "deeply rooted; firmly fixed or held"
    },
    {
        "word": "quagmire",
        "difficulty": 6043.59,
        "definition": "a soft wet area of low-lying land that sinks underfoot"
    },
    {
        "word": "reprobation",
        "difficulty": 6071.52,
        "definition": "severe disapproval"
    },
    {
        "word": "mannered",
        "difficulty": 6090.29,
        "definition": "having unnatural behavioral attributes"
    },
    {
        "word": "squeamish",
        "difficulty": 6137.71,
        "definition": "easily disturbed or disgusted by unpleasant things"
    },
    {
        "word": "proclivity",
        "difficulty": 6169.74,
        "definition": "a natural inclination"
    },
    {
        "word": "miserly",
        "difficulty": 6202.11,
        "definition": "characterized by or indicative of lack of generosity"
    },
    {
        "word": "vapid",
        "difficulty": 6238.1,
        "definition": "lacking significance or liveliness or spirit or zest"
    },
    {
        "word": "mercurial",
        "difficulty": 6241.4,
        "definition": "liable to sudden unpredictable change"
    },
    {
        "word": "perspicuous",
        "difficulty": 6277.85,
        "definition": "transparently clear; easily understandable"
    },
    {
        "word": "nonplus",
        "difficulty": 6308,
        "definition": "be a mystery or bewildering to"
    },
    {
        "word": "enamor",
        "difficulty": 6321.49,
        "definition": "attract"
    },
    {
        "word": "hackneyed",
        "difficulty": 6328.25,
        "definition": "repeated too often; overfamiliar through overuse"
    },
    {
        "word": "spate",
        "difficulty": 6345.24,
        "definition": "a large number or amount or extent"
    },
    {
        "word": "pedagogue",
        "difficulty": 6376.03,
        "definition": "someone who educates young people"
    },
    {
        "word": "acme",
        "difficulty": 6424.54,
        "definition": "the highest level or degree attainable"
    },
    {
        "word": "masticate",
        "difficulty": 6424.54,
        "definition": "bite and grind with the teeth"
    },
    {
        "word": "sinecure",
        "difficulty": 6495.13,
        "definition": "a job that involves minimal duties"
    },
    {
        "word": "indite",
        "difficulty": 6513.02,
        "definition": "produce a literary work"
    },
    {
        "word": "emetic",
        "difficulty": 6541.85,
        "definition": "a medicine that induces nausea and vomiting"
    },
    {
        "word": "temporize",
        "difficulty": 6545.47,
        "definition": "draw out a discussion or process in order to gain time"
    },
    {
        "word": "unimpeachable",
        "difficulty": 6570.93,
        "definition": "beyond doubt or reproach"
    },
    {
        "word": "genesis",
        "difficulty": 6581.91,
        "definition": "a coming into being"
    },
    {
        "word": "mordant",
        "difficulty": 6589.24,
        "definition": "harshly ironic or sinister"
    },
    {
        "word": "smattering",
        "difficulty": 6603.97,
        "definition": "a small number or amount"
    },
    {
        "word": "suavity",
        "difficulty": 6626.17,
        "definition": "the quality of being charming and gracious in manner"
    },
    {
        "word": "stentorian",
        "difficulty": 6644.79,
        "definition": "very loud or booming"
    },
    {
        "word": "junket",
        "difficulty": 6671.04,
        "definition": "a trip taken by an official at public expense"
    },
    {
        "word": "appurtenance",
        "difficulty": 6686.13,
        "definition": "a supplementary component that improves capability"
    },
    {
        "word": "nostrum",
        "difficulty": 6712.7,
        "definition": "patent medicine whose efficacy is questionable"
    },
    {
        "word": "immure",
        "difficulty": 6739.49,
        "definition": "lock up or confine, in or as in a jail"
    },
    {
        "word": "astringent",
        "difficulty": 6754.89,
        "definition": "acidic or bitter in taste or smell"
    },
    {
        "word": "unfaltering",
        "difficulty": 6766.49,
        "definition": "marked by firm determination or resolution; not shakable"
    },
    {
        "word": "tutelage",
        "difficulty": 6809.36,
        "definition": "attention and management implying responsibility for safety"
    },
    {
        "word": "testator",
        "difficulty": 6825.08,
        "definition": "a person who makes a will"
    },
    {
        "word": "elysian",
        "difficulty": 6832.97,
        "definition": "of such excellence as to suggest inspiration by the gods"
    },
    {
        "word": "fulminate",
        "difficulty": 6840.88,
        "definition": "criticize severely"
    },
    {
        "word": "fractious",
        "difficulty": 6848.8,
        "definition": "easily irritated or annoyed"
    },
    {
        "word": "pummel",
        "difficulty": 6852.77,
        "definition": "strike, usually with the fist"
    },
    {
        "word": "manumit",
        "difficulty": 6856.75,
        "definition": "free from slavery or servitude"
    },
    {
        "word": "unexceptionable",
        "difficulty": 6864.71,
        "definition": "completely acceptable; not open to reproach"
    },
    {
        "word": "triumvirate",
        "difficulty": 6888.71,
        "definition": "a group of three people responsible for civil authority"
    },
    {
        "word": "sybarite",
        "difficulty": 6920.97,
        "definition": "a person addicted to luxury and pleasures of the senses"
    },
    {
        "word": "jibe",
        "difficulty": 6949.45,
        "definition": "be compatible, similar, or consistent"
    },
    {
        "word": "magisterial",
        "difficulty": 6953.54,
        "definition": "offensively self-assured or exercising unwarranted power"
    },
    {
        "word": "roseate",
        "difficulty": 6969.93,
        "definition": "of something having a dusty purplish pink color"
    },
    {
        "word": "obloquy",
        "difficulty": 7011.27,
        "definition": "abusive, malicious, and condemnatory language"
    },
    {
        "word": "hoodwink",
        "difficulty": 7023.76,
        "definition": "influence by slyness"
    },
    {
        "word": "striate",
        "difficulty": 7078.43,
        "definition": "mark with stripes of contrasting color"
    },
    {
        "word": "arrogate",
        "difficulty": 7086.92,
        "definition": "seize and take control without authority"
    },
    {
        "word": "rarefied",
        "difficulty": 7142.58,
        "definition": "of high moral or intellectual value"
    },
    {
        "word": "chary",
        "difficulty": 7296.87,
        "definition": "characterized by great caution"
    },
    {
        "word": "credo",
        "difficulty": 7305.89,
        "definition": "any system of principles or beliefs"
    },
    {
        "word": "superannuated",
        "difficulty": 7319.46,
        "definition": "too old to be useful"
    },
    {
        "word": "impolitic",
        "difficulty": 7333.08,
        "definition": "lacking tact, shrewdness, or prudence"
    },
    {
        "word": "aspersion",
        "difficulty": 7342.19,
        "definition": "a disparaging remark"
    },
    {
        "word": "abysmal",
        "difficulty": 7346.75,
        "definition": "exceptionally bad or displeasing"
    },
    {
        "word": "poignancy",
        "difficulty": 7365.06,
        "definition": "a quality that arouses emotions, especially pity or sorrow"
    },
    {
        "word": "stilted",
        "difficulty": 7411.23,
        "definition": "artificially formal or stiff"
    },
    {
        "word": "effete",
        "difficulty": 7420.53,
        "definition": "excessively self-indulgent, affected, or decadent"
    },
    {
        "word": "provender",
        "difficulty": 7420.53,
        "definition": "food for domestic livestock"
    },
    {
        "word": "endemic",
        "difficulty": 7425.19,
        "definition": "of a disease constantly present in a particular locality"
    },
    {
        "word": "jocund",
        "difficulty": 7491.06,
        "definition": "full of or showing high-spirited merriment"
    },
    {
        "word": "procedural",
        "difficulty": 7500.56,
        "definition": "of or relating to processes"
    },
    {
        "word": "rakish",
        "difficulty": 7505.32,
        "definition": "marked by a carefree unconventionality or disreputableness"
    },
    {
        "word": "skittish",
        "difficulty": 7514.87,
        "definition": "unpredictably excitable, especially of horses"
    },
    {
        "word": "peroration",
        "difficulty": 7543.64,
        "definition": "a flowery and highly rhetorical address"
    },
    {
        "word": "nonentity",
        "difficulty": 7553.28,
        "definition": "a person of no influence"
    },
    {
        "word": "abstemious",
        "difficulty": 7558.1,
        "definition": "marked by temperance in indulgence"
    },
    {
        "word": "viscid",
        "difficulty": 7562.94,
        "definition": "having the sticky properties of an adhesive"
    },
    {
        "word": "doggerel",
        "difficulty": 7592.08,
        "definition": "a comic verse of irregular measure"
    },
    {
        "word": "sleight",
        "difficulty": 7596.96,
        "definition": "adroitness in using the hands"
    },
    {
        "word": "rubric",
        "difficulty": 7636.21,
        "definition": "category name"
    },
    {
        "word": "plenitude",
        "difficulty": 7675.88,
        "definition": "a full supply"
    },
    {
        "word": "rebus",
        "difficulty": 7705.9,
        "definition": "a puzzle consisting of pictures representing words"
    },
    {
        "word": "wizened",
        "difficulty": 7715.95,
        "definition": "lean and wrinkled by shrinkage as from age or illness"
    },
    {
        "word": "whorl",
        "difficulty": 7731.09,
        "definition": "a round shape formed by a series of concentric circles"
    },
    {
        "word": "fracas",
        "difficulty": 7736.15,
        "definition": "a noisy quarrel"
    },
    {
        "word": "iconoclast",
        "difficulty": 7766.64,
        "definition": "someone who attacks cherished ideas or institutions"
    },
    {
        "word": "saturnine",
        "difficulty": 7828.36,
        "definition": "bitter or scornful"
    },
    {
        "word": "madrigal",
        "difficulty": 7864.81,
        "definition": "an unaccompanied partsong for several voices"
    },
    {
        "word": "discursive",
        "difficulty": 7875.29,
        "definition": "tending to cover a wide range of subjects"
    },
    {
        "word": "zealot",
        "difficulty": 7928.1,
        "definition": "a fervent and even militant proponent of something"
    },
    {
        "word": "moribund",
        "difficulty": 7944.09,
        "definition": "not growing or changing; without force or vitality"
    },
    {
        "word": "modicum",
        "difficulty": 7944.09,
        "definition": "a small or moderate or token amount"
    },
    {
        "word": "connotation",
        "difficulty": 7949.43,
        "definition": "an idea that is implied or suggested"
    },
    {
        "word": "adventitious",
        "difficulty": 7965.5,
        "definition": "associated by chance and not an integral part"
    },
    {
        "word": "recondite",
        "difficulty": 8008.66,
        "definition": "difficult to understand"
    },
    {
        "word": "zephyr",
        "difficulty": 8052.3,
        "definition": "a slight wind"
    },
    {
        "word": "countermand",
        "difficulty": 8057.79,
        "definition": "cancel officially"
    },
    {
        "word": "captious",
        "difficulty": 8063.29,
        "definition": "tending to find and call attention to faults"
    },
    {
        "word": "cognate",
        "difficulty": 8079.82,
        "definition": "having the same ancestral language"
    },
    {
        "word": "forebear",
        "difficulty": 8124.24,
        "definition": "a person from whom you are descended"
    },
    {
        "word": "cadaverous",
        "difficulty": 8146.63,
        "definition": "very thin especially from disease or hunger or cold"
    },
    {
        "word": "foist",
        "difficulty": 8157.87,
        "definition": "force onto another"
    },
    {
        "word": "dotage",
        "difficulty": 8191.79,
        "definition": "mental infirmity as a consequence of old age"
    },
    {
        "word": "nexus",
        "difficulty": 8225.99,
        "definition": "a connected series or group"
    },
    {
        "word": "choleric",
        "difficulty": 8324.46,
        "definition": "characterized by anger"
    },
    {
        "word": "garble",
        "difficulty": 8330.32,
        "definition": "distort or make false by mutilation or addition"
    },
    {
        "word": "bucolic",
        "difficulty": 8353.87,
        "definition": "idyllically rustic"
    },
    {
        "word": "denouement",
        "difficulty": 8395.4,
        "definition": "the outcome of a complex sequence of events"
    },
    {
        "word": "animus",
        "difficulty": 8407.34,
        "definition": "a feeling of ill will arousing active hostility"
    },
    {
        "word": "overweening",
        "difficulty": 8449.4,
        "definition": "unrestrained, especially with regard to feelings"
    },
    {
        "word": "tyro",
        "difficulty": 8461.49,
        "definition": "someone new to a field or activity"
    },
    {
        "word": "preen",
        "difficulty": 8461.49,
        "definition": "dress or groom with elaborate care"
    },
    {
        "word": "largesse",
        "difficulty": 8461.49,
        "definition": "liberality in bestowing gifts"
    },
    {
        "word": "retentive",
        "difficulty": 8504.1,
        "definition": "good at remembering"
    },
    {
        "word": "unconscionable",
        "difficulty": 8559.52,
        "definition": "greatly exceeding bounds of reason or moderation"
    },
    {
        "word": "badinage",
        "difficulty": 8571.93,
        "definition": "frivolous banter"
    },
    {
        "word": "insensate",
        "difficulty": 8609.38,
        "definition": "devoid of feeling and consciousness and animation"
    },
    {
        "word": "sherbet",
        "difficulty": 8685.28,
        "definition": "a frozen dessert made primarily of fruit juice and sugar"
    },
    {
        "word": "beatific",
        "difficulty": 8691.67,
        "definition": "resembling or befitting an angel or saint"
    },
    {
        "word": "bemuse",
        "difficulty": 8717.31,
        "definition": "cause to be confused emotionally"
    },
    {
        "word": "microcosm",
        "difficulty": 8775.54,
        "definition": "a miniature model of something"
    },
    {
        "word": "factitious",
        "difficulty": 8795.13,
        "definition": "not produced by natural forces; artificial or fake"
    },
    {
        "word": "gestate",
        "difficulty": 8867.7,
        "definition": "develop in the mind; have the idea for"
    },
    {
        "word": "traduce",
        "difficulty": 8887.7,
        "definition": "speak unfavorably about"
    },
    {
        "word": "sextant",
        "difficulty": 8975.42,
        "definition": "an instrument for measuring angular distance"
    },
    {
        "word": "coiffure",
        "difficulty": 9064.89,
        "definition": "the arrangement of the hair"
    },
    {
        "word": "malleable",
        "difficulty": 9078.81,
        "definition": "easily influenced"
    },
    {
        "word": "rococo",
        "difficulty": 9092.78,
        "definition": "having excessive asymmetrical ornamentation"
    },
    {
        "word": "fructify",
        "difficulty": 9142,
        "definition": "become productive or fruitful"
    },
    {
        "word": "nihilist",
        "difficulty": 9142,
        "definition": "someone who rejects all theories of morality"
    },
    {
        "word": "ellipsis",
        "difficulty": 9177.48,
        "definition": "omission or suppression of parts of words or sentences"
    },
    {
        "word": "accolade",
        "difficulty": 9184.61,
        "definition": "a tangible symbol signifying approval or distinction"
    },
    {
        "word": "codicil",
        "difficulty": 9198.91,
        "definition": "a supplement to a will"
    },
    {
        "word": "roil",
        "difficulty": 9213.25,
        "definition": "be agitated"
    },
    {
        "word": "grandiloquent",
        "difficulty": 9213.25,
        "definition": "lofty in style"
    },
    {
        "word": "inconsequential",
        "difficulty": 9227.63,
        "definition": "lacking worth or importance"
    },
    {
        "word": "effervescence",
        "difficulty": 9263.78,
        "definition": "the property of giving off bubbles"
    },
    {
        "word": "stultify",
        "difficulty": 9359.12,
        "definition": "deprive of strength or efficiency; make useless or worthless"
    },
    {
        "word": "tureen",
        "difficulty": 9366.54,
        "definition": "large deep serving dish with a cover"
    },
    {
        "word": "pellucid",
        "difficulty": 9366.54,
        "definition": "transparently clear; easily understandable"
    },
    {
        "word": "euphony",
        "difficulty": 9366.54,
        "definition": "any pleasing and harmonious sounds"
    },
    {
        "word": "apocryphal",
        "difficulty": 9396.32,
        "definition": "being of questionable authenticity"
    },
    {
        "word": "veracious",
        "difficulty": 9479.2,
        "definition": "precisely accurate"
    },
    {
        "word": "pendulous",
        "difficulty": 9479.2,
        "definition": "hanging loosely or bending downward"
    },
    {
        "word": "exegesis",
        "difficulty": 9494.42,
        "definition": "an explanation or critical interpretation"
    },
    {
        "word": "effluvium",
        "difficulty": 9509.7,
        "definition": "a foul-smelling outflow or vapor"
    },
    {
        "word": "apposite",
        "difficulty": 9610.2,
        "definition": "being of striking appropriateness and pertinence"
    },
    {
        "word": "viscous",
        "difficulty": 9665.2,
        "definition": "having the sticky properties of an adhesive"
    },
    {
        "word": "misanthrope",
        "difficulty": 9673.1,
        "definition": "someone who dislikes people in general"
    },
    {
        "word": "vintner",
        "difficulty": 9696.91,
        "definition": "someone who makes wine"
    },
    {
        "word": "halcyon",
        "difficulty": 9720.83,
        "definition": "idyllically calm and peaceful; suggesting happy tranquility"
    },
    {
        "word": "anthropomorphic",
        "difficulty": 9801.42,
        "definition": "suggesting human features for animals or inanimate things"
    },
    {
        "word": "turgid",
        "difficulty": 9866.87,
        "definition": "ostentatiously lofty in style"
    },
    {
        "word": "malaise",
        "difficulty": 9883.37,
        "definition": "a general feeling of discomfort, uneasiness, or depression"
    },
    {
        "word": "polemical",
        "difficulty": 9916.53,
        "definition": "of or involving dispute or controversy"
    },
    {
        "word": "gadfly",
        "difficulty": 9991.96,
        "definition": "a persistently annoying person"
    },
    {
        "word": "atavism",
        "difficulty": 10120.27,
        "definition": "a reappearance of an earlier characteristic"
    },
    {
        "word": "contusion",
        "difficulty": 10314.53,
        "definition": "an injury in which the skin is not broken"
    },
    {
        "word": "parsimonious",
        "difficulty": 10387.04,
        "definition": "excessively unwilling to spend"
    },
    {
        "word": "dulcet",
        "difficulty": 10497.72,
        "definition": "pleasing to the ear"
    },
    {
        "word": "reprise",
        "difficulty": 10516.4,
        "definition": "repeat an earlier theme of a composition"
    },
    {
        "word": "anodyne",
        "difficulty": 10535.15,
        "definition": "capable of relieving pain"
    },
    {
        "word": "bemused",
        "difficulty": 10553.96,
        "definition": "perplexed by many conflicting situations or statements"
    }
]
